/**
 * ❗GENERATED FILE. DO NOT EDIT❗
 *
 * Generated by api-v2/scripts/create-api-client-types.ts
 */

import type { ModelName } from './typeDefs';

export type Ref<_T extends string> = string;
type ObjectId = string;
/**
 * All models defined in api-v2 repo
 */
export type ApiV2ModelName = (typeof API_V2_MODEL_NAMES)[number];
type Moment = string;
export type JsonSchema = { type: string; [key: string]: any };
export type TransformerExpressionSchema = import('@pi/transformer-compiler').Expression;

export type Pv2CustomFieldNodeCommon = {
    id: string;
    label: string;
    description?: string;
    clearOnChange?: string[];
    location: { path?: string; attribute?: string };
    format?: { type: string };
    validators?: Array<{ type: string }>;
    dataHealthWeight?: number;
};

export interface AjvError<K extends string = string, P = Record<string, any>, S = unknown> {
    keyword: K;
    instancePath: string;
    schemaPath: string;
    params: P;
    propertyName?: string;
    message?: string;
    schema?: S;
    parentSchema?: Record<string, any>;
    data?: unknown;
}

export type Pv2CustomFieldNode = Pv2CustomFieldNodeCommon &
    (
        | {
              type: 'string';
              validators: Array<{ type: 'string' }>;
          }
        | { type: 'boolean' }
        | {
              type: 'select';
              config: {
                  multiple?: boolean;
                  options: Array<{
                      label: string;
                      value: string | number;
                  }>;
              };
          }
        | {
              type: 'object';
              config: {
                  children: Pv2CustomFieldNode[];
              };
          }
        | {
              type: 'array';
              config: {
                  childType: Pv2CustomFieldNode;
                  minItems?: number;
                  maxItems?: number;
              };
          }
    );

export const API_V2_MODEL_NAMES = [
    'AliasMapping',
    'AmazonProduct',
    'AnalyticsClientFeedbackJiraIssue',
    'AnalyticsClientFeedbackSpinsAttribute',
    'AnalyticsClientFeedbackTrackerUpdate',
    'AnalyticsOperationalKPI',
    'AnalyticsProductCount',
    'AnalyticsQCSelfServe',
    'ApertureAnnotation',
    'AutoNotifications',
    'BrandReview',
    'BuilderBatch',
    'CircanaBrandMapping',
    'CleansedData',
    'ClientTrackerValue',
    'Company',
    'CompanySignupRequest',
    'Config',
    'DeleteHistory',
    'DigitizationUpcScan',
    'DigitizationUpdate',
    'DigitizationUserStatus',
    'Domain',
    'FeatureFlagConfiguration',
    'Form',
    'FormInstruction',
    'Formula',
    'FormulaResource',
    'GS1TaxonomyMapping',
    'GcpScriptLog',
    'HierarchyAllowedValues',
    'HierarchyMapping',
    'Image',
    'Ingestion',
    'Jwt',
    'LockedValues',
    'MaskedUpc',
    'MturkHIT',
    'MturkWorker',
    'NfpAttributeMapping',
    'Period',
    'PreProductionNtc',
    'PreProductionNtu',
    'PredictionOverride',
    'PrivateLabelPermanentProduct',
    'PrivateLabelProduct',
    'ProductEditRequest',
    'ProductSentToTarget',
    'Pv2',
    'Pv2AttributeDefinition',
    'Pv2CustomFieldConfig',
    'Pv2Ingredient',
    'Pv2Verification',
    'RawIngestionData',
    'RawIngestionEvent',
    'RetailItemsExtract',
    'RetailerPrivateLabel',
    'Script',
    'ServicesHeartbeat',
    'SnapshotTags',
    'SpinsAttributeType',
    'SpinsAttributes',
    'Store',
    'Tag',
    'Task',
    'TaskDefinition',
    'Taxonomy',
    'TransformerExpression',
    'TransformerResource',
    'User',
    'UserBatch',
    'UserSearch',
    'Whitelist',
] as const;

export type ModelTypes = {
    AliasMapping: {
        input: AliasMappingInput;
        output: AliasMappingOutput;
    };
    AmazonProduct: {
        input: AmazonProductInput;
        output: AmazonProductOutput;
    };
    AnalyticsClientFeedbackJiraIssue: {
        input: AnalyticsClientFeedbackJiraIssueInput;
        output: AnalyticsClientFeedbackJiraIssueOutput;
    };
    AnalyticsClientFeedbackSpinsAttribute: {
        input: AnalyticsClientFeedbackSpinsAttributeInput;
        output: AnalyticsClientFeedbackSpinsAttributeOutput;
    };
    AnalyticsClientFeedbackTrackerUpdate: {
        input: AnalyticsClientFeedbackTrackerUpdateInput;
        output: AnalyticsClientFeedbackTrackerUpdateOutput;
    };
    AnalyticsOperationalKPI: {
        input: AnalyticsOperationalKPIInput;
        output: AnalyticsOperationalKPIOutput;
    };
    AnalyticsProductCount: {
        input: AnalyticsProductCountInput;
        output: AnalyticsProductCountOutput;
    };
    AnalyticsQCSelfServe: {
        input: AnalyticsQCSelfServeInput;
        output: AnalyticsQCSelfServeOutput;
    };
    ApertureAnnotation: {
        input: ApertureAnnotationInput;
        output: ApertureAnnotationOutput;
    };
    AutoNotifications: {
        input: AutoNotificationsInput;
        output: AutoNotificationsOutput;
    };
    BrandReview: {
        input: BrandReviewInput;
        output: BrandReviewOutput;
    };
    BuilderBatch: {
        input: BuilderBatchInput;
        output: BuilderBatchOutput;
    };
    CircanaBrandMapping: {
        input: CircanaBrandMappingInput;
        output: CircanaBrandMappingOutput;
    };
    CleansedData: {
        input: CleansedDataInput;
        output: CleansedDataOutput;
    };
    ClientTrackerValue: {
        input: ClientTrackerValueInput;
        output: ClientTrackerValueOutput;
    };
    Company: {
        input: CompanyInput;
        output: CompanyOutput;
    };
    CompanySignupRequest: {
        input: CompanySignupRequestInput;
        output: CompanySignupRequestOutput;
    };
    Config: {
        input: ConfigInput;
        output: ConfigOutput;
    };
    DeleteHistory: {
        input: DeleteHistoryInput;
        output: DeleteHistoryOutput;
    };
    DigitizationUpcScan: {
        input: DigitizationUpcScanInput;
        output: DigitizationUpcScanOutput;
    };
    DigitizationUpdate: {
        input: DigitizationUpdateInput;
        output: DigitizationUpdateOutput;
    };
    DigitizationUserStatus: {
        input: DigitizationUserStatusInput;
        output: DigitizationUserStatusOutput;
    };
    Domain: {
        input: DomainInput;
        output: DomainOutput;
    };
    FeatureFlagConfiguration: {
        input: FeatureFlagConfigurationInput;
        output: FeatureFlagConfigurationOutput;
    };
    Form: {
        input: FormInput;
        output: FormOutput;
    };
    FormInstruction: {
        input: FormInstructionInput;
        output: FormInstructionOutput;
    };
    Formula: {
        input: FormulaInput;
        output: FormulaOutput;
    };
    FormulaResource: {
        input: FormulaResourceInput;
        output: FormulaResourceOutput;
    };
    GS1TaxonomyMapping: {
        input: GS1TaxonomyMappingInput;
        output: GS1TaxonomyMappingOutput;
    };
    GcpScriptLog: {
        input: GcpScriptLogInput;
        output: GcpScriptLogOutput;
    };
    HierarchyAllowedValues: {
        input: HierarchyAllowedValuesInput;
        output: HierarchyAllowedValuesOutput;
    };
    HierarchyMapping: {
        input: HierarchyMappingInput;
        output: HierarchyMappingOutput;
    };
    Image: {
        input: ImageInput;
        output: ImageOutput;
    };
    Ingestion: {
        input: IngestionInput;
        output: IngestionOutput;
    };
    Jwt: {
        input: JwtInput;
        output: JwtOutput;
    };
    LockedValues: {
        input: LockedValuesInput;
        output: LockedValuesOutput;
    };
    MaskedUpc: {
        input: MaskedUpcInput;
        output: MaskedUpcOutput;
    };
    MturkHIT: {
        input: MturkHITInput;
        output: MturkHITOutput;
    };
    MturkWorker: {
        input: MturkWorkerInput;
        output: MturkWorkerOutput;
    };
    NfpAttributeMapping: {
        input: NfpAttributeMappingInput;
        output: NfpAttributeMappingOutput;
    };
    Period: {
        input: PeriodInput;
        output: PeriodOutput;
    };
    PreProductionNtc: {
        input: PreProductionNtcInput;
        output: PreProductionNtcOutput;
    };
    PreProductionNtu: {
        input: PreProductionNtuInput;
        output: PreProductionNtuOutput;
    };
    PredictionOverride: {
        input: PredictionOverrideInput;
        output: PredictionOverrideOutput;
    };
    PrivateLabelPermanentProduct: {
        input: PrivateLabelPermanentProductInput;
        output: PrivateLabelPermanentProductOutput;
    };
    PrivateLabelProduct: {
        input: PrivateLabelProductInput;
        output: PrivateLabelProductOutput;
    };
    ProductEditRequest: {
        input: ProductEditRequestInput;
        output: ProductEditRequestOutput;
    };
    ProductSentToTarget: {
        input: ProductSentToTargetInput;
        output: ProductSentToTargetOutput;
    };
    Pv2: {
        input: Pv2Input;
        output: Pv2Output;
    };
    Pv2AttributeDefinition: {
        input: Pv2AttributeDefinitionInput;
        output: Pv2AttributeDefinitionOutput;
    };
    Pv2CustomFieldConfig: {
        input: Pv2CustomFieldConfigInput;
        output: Pv2CustomFieldConfigOutput;
    };
    Pv2Ingredient: {
        input: Pv2IngredientInput;
        output: Pv2IngredientOutput;
    };
    Pv2Verification: {
        input: Pv2VerificationInput;
        output: Pv2VerificationOutput;
    };
    RawIngestionData: {
        input: RawIngestionDataInput;
        output: RawIngestionDataOutput;
    };
    RawIngestionEvent: {
        input: RawIngestionEventInput;
        output: RawIngestionEventOutput;
    };
    RetailItemsExtract: {
        input: RetailItemsExtractInput;
        output: RetailItemsExtractOutput;
    };
    RetailerPrivateLabel: {
        input: RetailerPrivateLabelInput;
        output: RetailerPrivateLabelOutput;
    };
    Script: {
        input: ScriptInput;
        output: ScriptOutput;
    };
    ServicesHeartbeat: {
        input: ServicesHeartbeatInput;
        output: ServicesHeartbeatOutput;
    };
    SnapshotTags: {
        input: SnapshotTagsInput;
        output: SnapshotTagsOutput;
    };
    SpinsAttributeType: {
        input: SpinsAttributeTypeInput;
        output: SpinsAttributeTypeOutput;
    };
    SpinsAttributes: {
        input: SpinsAttributesInput;
        output: SpinsAttributesOutput;
    };
    Store: {
        input: StoreInput;
        output: StoreOutput;
    };
    Tag: {
        input: TagInput;
        output: TagOutput;
    };
    Task: {
        input: TaskInput;
        output: TaskOutput;
    };
    TaskDefinition: {
        input: TaskDefinitionInput;
        output: TaskDefinitionOutput;
    };
    Taxonomy: {
        input: TaxonomyInput;
        output: TaxonomyOutput;
    };
    TransformerExpression: {
        input: TransformerExpressionInput;
        output: TransformerExpressionOutput;
    };
    TransformerResource: {
        input: TransformerResourceInput;
        output: TransformerResourceOutput;
    };
    User: {
        input: UserInput;
        output: UserOutput;
    };
    UserBatch: {
        input: UserBatchInput;
        output: UserBatchOutput;
    };
    UserSearch: {
        input: UserSearchInput;
        output: UserSearchOutput;
    };
    Whitelist: {
        input: WhitelistInput;
        output: WhitelistOutput;
    };
};

/**
 * Input type for AliasMapping.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AliasMappingInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    spinsRetailerId: string;
    spinsItemCode: string;
    itemCode?: string | null;
    itemDescription: string;
    isPlu?: string | null;
    produceMatchedSpinsItemCode?: string | null;
    predictedProductType?: string | null;
    pucPredictions?: string | null;
    modelVersion?: string | null;
    spinsUpc?: string | null;
    confidenceScore?: number | null;
    binaryScore?: number | null;
    biEncoderScore?: number | null;
    averagePrice?: number | null;
    annotatedSpinsUpc?: string | null;
    annotatedSpinsUpcUpdatedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AliasMapping.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AliasMappingOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    spinsRetailerId: string;
    spinsItemCode: string;
    itemCode?: string | null;
    itemDescription: string;
    isPlu?: string | null;
    produceMatchedSpinsItemCode?: string | null;
    predictedProductType?: string | null;
    pucPredictions?: string | null;
    modelVersion?: string | null;
    spinsUpc?: string | null;
    confidenceScore?: number | null;
    binaryScore?: number | null;
    biEncoderScore?: number | null;
    averagePrice?: number | null;
    annotatedSpinsUpc?: string | null;
    annotatedSpinsUpcUpdatedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AmazonProduct.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Product Description Page scraped from Amazon
 */
export interface AmazonProductInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    asin?: string | null;
    /** - default: `[]` */
    alsoBought?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    alsoViewed?: Array<Record<string, any>> | null;
    amazonsChoice?: Record<string, any> | null;
    /** - default: `[]` */
    attributes?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    bestsellersRank?: Array<Record<string, any>> | null;
    brand?: string | null;
    brandStore?: Record<string, any> | null;
    /** - default: `[]` */
    bundles?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    bundleContents?: Array<Record<string, any>> | null;
    buyboxWinner?: Record<string, any> | null;
    /** - default: `[]` */
    categories?: Array<Record<string, any>> | null;
    couponText?: string | null;
    /** String date in the format of YYYY-MM-DD */
    dateParsed: string;
    deliveryMessage?: string | null;
    dimensions?: string | null;
    firstAvailable?: Record<string, any> | null;
    /** - default: `[]` */
    featureBullets?: Array<string> | null;
    frequentlyBoughtTogether?: Record<string, any> | null;
    gtin: string;
    hasCoupon?: boolean | null;
    /** - default: `[]` */
    images?: Array<Record<string, any>> | null;
    importantInformation?: {
        /** - default: `[]` */
        sections?: Array<Record<string, any>> | null;
    } | null;
    isBundle?: boolean | null;
    keywords?: string | null;
    /** - default: `[]` */
    keywordsList?: Array<string> | null;
    kindleUnlimited?: boolean | null;
    link?: string | null;
    mainImage?: Record<string, any> | null;
    /** - default: `[]` */
    moreBuyingChoices?: Array<Record<string, any>> | null;
    parentAsin?: string | null;
    /** - default: `[]` */
    promotions?: Array<Record<string, any>> | null;
    pv2IdOrigins?: Record<string, any> | null;
    rating?: number | null;
    ratingsTotal?: number | null;
    requestMetadata?: Record<string, any> | null;
    requestParameters?: Record<string, any> | null;
    reviewsTotal?: number | null;
    /** - default: `[]` */
    services?: Array<Record<string, any>> | null;
    shippingWeight?: string | null;
    shopByLook?: Record<string, any> | null;
    /** - default: `[]` */
    specifications?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    sponsoredProducts?: Array<Record<string, any>> | null;
    /**
     * - default: `active`
     * - index
     */
    status?: ('active' | 'inactive' | 'missing') | null;
    subTitle?: Record<string, any> | null;
    /** - default: `[]` */
    summarizationAttributes?: Array<Record<string, any>> | null;
    title?: string | null;
    /** - default: `[]` */
    topReviews?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    variants?: Array<Record<string, any>> | null;
    /** - default: `[]` */
    videos?: Array<Record<string, any>> | null;
    weight?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AmazonProduct.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Product Description Page scraped from Amazon
 */
export interface AmazonProductOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    asin?: string | null;
    /** - default: `[]` */
    alsoBought: Array<Record<string, any>>;
    /** - default: `[]` */
    alsoViewed: Array<Record<string, any>>;
    amazonsChoice?: Record<string, any> | null;
    /** - default: `[]` */
    attributes: Array<Record<string, any>>;
    /** - default: `[]` */
    bestsellersRank: Array<Record<string, any>>;
    brand?: string | null;
    brandStore?: Record<string, any> | null;
    /** - default: `[]` */
    bundles: Array<Record<string, any>>;
    /** - default: `[]` */
    bundleContents: Array<Record<string, any>>;
    buyboxWinner?: Record<string, any> | null;
    /** - default: `[]` */
    categories: Array<Record<string, any>>;
    couponText?: string | null;
    /** String date in the format of YYYY-MM-DD */
    dateParsed: string;
    deliveryMessage?: string | null;
    dimensions?: string | null;
    firstAvailable?: Record<string, any> | null;
    /** - default: `[]` */
    featureBullets: Array<string>;
    frequentlyBoughtTogether?: Record<string, any> | null;
    gtin: string;
    hasCoupon?: boolean | null;
    /** - default: `[]` */
    images: Array<Record<string, any>>;
    importantInformation?: {
        /** - default: `[]` */
        sections: Array<Record<string, any>>;
    } | null;
    isBundle?: boolean | null;
    keywords?: string | null;
    /** - default: `[]` */
    keywordsList: Array<string>;
    kindleUnlimited?: boolean | null;
    link?: string | null;
    mainImage?: Record<string, any> | null;
    /** - default: `[]` */
    moreBuyingChoices: Array<Record<string, any>>;
    parentAsin?: string | null;
    /** - default: `[]` */
    promotions: Array<Record<string, any>>;
    pv2IdOrigins?: Record<string, any> | null;
    rating?: number | null;
    ratingsTotal?: number | null;
    requestMetadata?: Record<string, any> | null;
    requestParameters?: Record<string, any> | null;
    reviewsTotal?: number | null;
    /** - default: `[]` */
    services: Array<Record<string, any>>;
    shippingWeight?: string | null;
    shopByLook?: Record<string, any> | null;
    /** - default: `[]` */
    specifications: Array<Record<string, any>>;
    /** - default: `[]` */
    sponsoredProducts: Array<Record<string, any>>;
    /**
     * - default: `active`
     * - index
     */
    status: 'active' | 'inactive' | 'missing';
    subTitle?: Record<string, any> | null;
    /** - default: `[]` */
    summarizationAttributes: Array<Record<string, any>>;
    title?: string | null;
    /** - default: `[]` */
    topReviews: Array<Record<string, any>>;
    /** - default: `[]` */
    variants: Array<Record<string, any>>;
    /** - default: `[]` */
    videos: Array<Record<string, any>>;
    weight?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsClientFeedbackJiraIssue.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsClientFeedbackJiraIssueInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    issueKey: string;
    clientName?: string | null;
    /** - default: `null` */
    created?: Moment | null;
    assignee?: string | null;
    reporter?: string | null;
    summary?: string | null;
    /** - default: `[]` */
    components?: Array<string> | null;
    /** - default: `[]` */
    rootCauses?: Array<string> | null;
    archive: boolean;
    /**
     * - default: `()`
     * - index
     */
    jiraUpdatedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsClientFeedbackJiraIssue.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsClientFeedbackJiraIssueOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    issueKey: string;
    clientName?: string | null;
    /** - default: `null` */
    created?: Moment | null;
    assignee?: string | null;
    reporter?: string | null;
    summary?: string | null;
    /** - default: `[]` */
    components: Array<string>;
    /** - default: `[]` */
    rootCauses: Array<string>;
    archive: boolean;
    /**
     * - default: `()`
     * - index
     */
    jiraUpdatedDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsClientFeedbackSpinsAttribute.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsClientFeedbackSpinsAttributeInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    spinsUpc: string;
    brand?: string | null;
    category?: string | null;
    description?: string | null;
    subcategory?: string | null;
    department?: string | null;
    upcEan13?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsClientFeedbackSpinsAttribute.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsClientFeedbackSpinsAttributeOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    spinsUpc: string;
    brand?: string | null;
    category?: string | null;
    description?: string | null;
    subcategory?: string | null;
    department?: string | null;
    upcEan13?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsClientFeedbackTrackerUpdate.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsClientFeedbackTrackerUpdateInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    trackerId: string;
    spinsUpc: string;
    /** - index */
    jiraTicket?: string | null;
    jiraClientName?: string | null;
    jiraAssignee?: string | null;
    /**
     * - default: `false`
     * - index
     */
    clientValidatedCoding?: boolean | null;
    periodRelease?: string | null;
    /** - index */
    attributeName: string;
    /** - index */
    attributeValue: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsClientFeedbackTrackerUpdate.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsClientFeedbackTrackerUpdateOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    trackerId: string;
    spinsUpc: string;
    /** - index */
    jiraTicket?: string | null;
    jiraClientName?: string | null;
    jiraAssignee?: string | null;
    /**
     * - default: `false`
     * - index
     */
    clientValidatedCoding: boolean;
    periodRelease?: string | null;
    /** - index */
    attributeName: string;
    /** - index */
    attributeValue: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsOperationalKPI.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsOperationalKPIInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    type: 'Data Quality' | 'Customer Acceptance';
    name: string;
    value: number;
    valueType: 'Percentage' | 'Total Count' | 'Distinct Count';
    /** - default: `()` */
    datePulled?: Moment | null;
    period?: string | null;
    year?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsOperationalKPI.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsOperationalKPIOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    type: 'Data Quality' | 'Customer Acceptance';
    name: string;
    value: number;
    valueType: 'Percentage' | 'Total Count' | 'Distinct Count';
    /** - default: `()` */
    datePulled: Moment;
    period?: string | null;
    year?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsProductCount.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsProductCountInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    description: string;
    countType: 'spins_attributes_total' | 'pv2_asin_total';
    count: number;
    query?: string | null;
    /** - default: `[]` */
    collections?: Array<string> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsProductCount.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsProductCountOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    description: string;
    countType: 'spins_attributes_total' | 'pv2_asin_total';
    count: number;
    query?: string | null;
    /** - default: `[]` */
    collections: Array<string>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AnalyticsQCSelfServe.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface AnalyticsQCSelfServeInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    rowKey: string;
    team: 'DA&D' | 'PR';
    source: 'dh-check' | 'brand-position-rule';
    checkId: string;
    /** - index */
    pv2Id: string;
    spinsUpc?: string | null;
    mfrCode?: string | null;
    checkDescription?: string | null;
    expectedOutcome?: string | null;
    primaryAttribute?: string | null;
    primaryValue?: string | null;
    secondaryAttribute?: string | null;
    secondaryValue?: string | null;
    conflictingAttribute?: string | null;
    conflictingValue?: string | null;
    brand?: string | null;
    company?: string | null;
    description?: string | null;
    size?: string | null;
    unitOfMeasure?: string | null;
    department?: string | null;
    category?: string | null;
    subcategory?: string | null;
    productType?: string | null;
    functionalIngredient?: string | null;
    organic?: string | null;
    /** - default: `false` */
    delivered?: boolean | null;
    functionalIngredientFlag?: string | null;
    status?:
        | (
              | 'mismatch'
              | 'mismatch_low_confidence'
              | 'missing_brand_position_tag'
              | 'missing_brand_position_tag_low_confidence'
          )
        | null;
    expectedValue?: string | null;
    peerSupport?: string | null;
    lowConfidence?: boolean | null;
    pvlProp?: boolean | null;
    pvlConv?: boolean | null;
    channelProp?: boolean | null;
    channelConv?: boolean | null;
    /** - default: `()` */
    firstFlaggedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for AnalyticsQCSelfServe.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface AnalyticsQCSelfServeOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    rowKey: string;
    team: 'DA&D' | 'PR';
    source: 'dh-check' | 'brand-position-rule';
    checkId: string;
    /** - index */
    pv2Id: string;
    spinsUpc?: string | null;
    mfrCode?: string | null;
    checkDescription?: string | null;
    expectedOutcome?: string | null;
    primaryAttribute?: string | null;
    primaryValue?: string | null;
    secondaryAttribute?: string | null;
    secondaryValue?: string | null;
    conflictingAttribute?: string | null;
    conflictingValue?: string | null;
    brand?: string | null;
    company?: string | null;
    description?: string | null;
    size?: string | null;
    unitOfMeasure?: string | null;
    department?: string | null;
    category?: string | null;
    subcategory?: string | null;
    productType?: string | null;
    functionalIngredient?: string | null;
    organic?: string | null;
    /** - default: `false` */
    delivered: boolean;
    functionalIngredientFlag?: string | null;
    status?:
        | (
              | 'mismatch'
              | 'mismatch_low_confidence'
              | 'missing_brand_position_tag'
              | 'missing_brand_position_tag_low_confidence'
          )
        | null;
    expectedValue?: string | null;
    peerSupport?: string | null;
    lowConfidence?: boolean | null;
    pvlProp?: boolean | null;
    pvlConv?: boolean | null;
    channelProp?: boolean | null;
    channelConv?: boolean | null;
    /** - default: `()` */
    firstFlaggedDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for ApertureAnnotation.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Stores the raw annotation object returned from aperture when running scripts/importlatestApertureImagesAndData
 */
export interface ApertureAnnotationInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    pv2: Ref<'Pv2'>;
    /** - default: `[]` */
    value?: Array<ApertureAnnotationStructInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for ApertureAnnotation.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Stores the raw annotation object returned from aperture when running scripts/importlatestApertureImagesAndData
 */
export interface ApertureAnnotationOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    pv2: Ref<'Pv2'>;
    /** - default: `[]` */
    value: Array<ApertureAnnotationStructDoc>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for AutoNotifications.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Store cron notifications sent to brands/nhn
 */
export interface AutoNotificationsInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - default: `()` */
    createdDate?: Moment | null;
    email?: string | null;
    user?: Ref<'User'> | null;
    templateId?: string | null;
    notificationSubject?: string | null;
    domain?: Ref<'Domain'> | null;
}

/**
 * Output type for AutoNotifications.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Store cron notifications sent to brands/nhn
 */
export interface AutoNotificationsOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - default: `()` */
    createdDate: Moment;
    email?: string | null;
    user?: Ref<'User'> | null;
    templateId?: string | null;
    notificationSubject?: string | null;
    domain?: Ref<'Domain'> | null;
}

/**
 * Input type for BrandReview.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * A candidate pair of brand values that may be variants of one another, surfaced for manual review.
 * Rows are proposed by `scripts/brand-review-proposer.ts`, which runs one unpartitioned aggregation
 * over `SpinsAttributes.attributes[BRAND]` weekly and upserts the result here, keyed on `pairKey`.
 * This collection holds what the report shows plus the one key the weekly refresh
 * needs; the matching model's thresholds gate inside the aggregation and are not stored.
 * `opsReview` is where a decision will land. Nothing writes it yet - the proposer deliberately
 * never touches it, not even on insert - so an absent sub-document means "not yet reviewed".
 */
export interface BrandReviewInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * Stable natural key for the pair - the two RAW brand values joined by a double
     * pipe, shorter side first (e.g. "ANNIES||ANNIES HOMEGROWN"). Raw rather than
     * normalized because normalization is many-to-one, and keying on the normalized form
     * would collapse genuinely distinct pairs into one review row. This is the dedupe key
     * the proposer aggregation groups on, and what the weekly upsert matches against.
     * - unique
     */
    pairKey: string;
    /**
     * The raw BRAND attributeValue whose separator-free key is the shorter one.
     * - index
     */
    brandA: string;
    /** - index */
    brandB: string;
    /** Products carrying brandA, over the whole aggregated slice. */
    brandAItemCount: number;
    brandBItemCount: number;
    /**
     * Which rule paired these two values.
     * The report's filter column - a reviewer picks one reason and works that batch,
     * since the judgment each reason calls for is different.
     * - index
     */
    brandMatchReason: BrandMatchReasonEnum;
    /**
     * An ops decision on the pair. Absent until someone reviews it - the weekly
     * proposer writes nothing here, so a run can never move or clear a decision.
     * reviewStatus is required WITHIN the sub-document, so a decision cannot be
     * recorded without one, while the sub-document itself stays optional.
     * - default: `undefined`
     */
    opsReview?: {
        reviewStatus: BrandReviewStatusEnum;
        reasonCode?: BrandReviewReasonEnum | null;
        /** Which of the two brand values the reviewer kept. */
        survivingBrand?: string | null;
        /** - default: `undefined` */
        reviewer?: Ref<'User'> | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for BrandReview.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * A candidate pair of brand values that may be variants of one another, surfaced for manual review.
 * Rows are proposed by `scripts/brand-review-proposer.ts`, which runs one unpartitioned aggregation
 * over `SpinsAttributes.attributes[BRAND]` weekly and upserts the result here, keyed on `pairKey`.
 * This collection holds what the report shows plus the one key the weekly refresh
 * needs; the matching model's thresholds gate inside the aggregation and are not stored.
 * `opsReview` is where a decision will land. Nothing writes it yet - the proposer deliberately
 * never touches it, not even on insert - so an absent sub-document means "not yet reviewed".
 */
export interface BrandReviewOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * Stable natural key for the pair - the two RAW brand values joined by a double
     * pipe, shorter side first (e.g. "ANNIES||ANNIES HOMEGROWN"). Raw rather than
     * normalized because normalization is many-to-one, and keying on the normalized form
     * would collapse genuinely distinct pairs into one review row. This is the dedupe key
     * the proposer aggregation groups on, and what the weekly upsert matches against.
     * - unique
     */
    pairKey: string;
    /**
     * The raw BRAND attributeValue whose separator-free key is the shorter one.
     * - index
     */
    brandA: string;
    /** - index */
    brandB: string;
    /** Products carrying brandA, over the whole aggregated slice. */
    brandAItemCount: number;
    brandBItemCount: number;
    /**
     * Which rule paired these two values.
     * The report's filter column - a reviewer picks one reason and works that batch,
     * since the judgment each reason calls for is different.
     * - index
     */
    brandMatchReason: BrandMatchReasonEnum;
    /**
     * An ops decision on the pair. Absent until someone reviews it - the weekly
     * proposer writes nothing here, so a run can never move or clear a decision.
     * reviewStatus is required WITHIN the sub-document, so a decision cannot be
     * recorded without one, while the sub-document itself stays optional.
     * - default: `undefined`
     */
    opsReview?: {
        reviewStatus: BrandReviewStatusEnum;
        reasonCode?: BrandReviewReasonEnum | null;
        /** Which of the two brand values the reviewer kept. */
        survivingBrand?: string | null;
        /** - default: `undefined` */
        reviewer?: Ref<'User'> | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for BuilderBatch.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface BuilderBatchInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `pending`
     * - index
     */
    status?: ('pending' | 'processing' | 'done' | 'error' | 'cancelled') | null;
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate?: Moment | null;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
        /** While this batch is processing, this field is updated periodically with how many products have been processed */
        progress: number;
    } | null;
    /** - computed: default */
    name?: string | null;
    /**
     * A descriptive name for the batch to display in the UI when the batch trigger is not a simple/single
     * formula (e.g. triggering a recompute for a resource).
     */
    description?: string | null;
    /**
     * When enabled, an email will be sent to the user that created this batch
     * - default: `true`
     */
    notifyByEmail?: boolean | null;
    error?: string | null;
    errorStack?: string | null;
    saveToFile?: {
        /** When enabled, product data and artifacts will be stored to s3 and and s3Path will be created */
        enabled?: boolean | null;
        /** - default: `[]` */
        fields?: Array<string> | null;
        allVariables?: boolean | null;
        /** - default: `jsonl` */
        format?: BuilderBatchSaveToFileFormatEnum | null;
        /**
         * bucket/key
         * - computed: overwrite
         */
        s3Path?: string | null;
        /**
         * When true, filters output file to only include Pv2's that are (or would be) updated.
         * Otherwise, report file will include all Pv2's from the batch.
         */
        onlyIncludeUpdatedPv2s?: boolean | null;
    } | null;
    saveToBigQuery?: boolean | null;
    /**
     * Set to true to apply recomputations from the batch back to the database
     * - default: `false`
     */
    saveComputationsToPv2s?: boolean | null;
    /** - default: `false` */
    cancellationRequested?: boolean | null;
    /** - index */
    environment?: string | null;
    _query?: string | null;
    _runStats?: string | null;
    /** - computed: overwrite */
    _formula?: string | null;
    limit?: number | null;
    /** - default: `false` */
    includeArtifacts?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    query?: Record<string, any> | null;
    /** @virtual */
    runStats?: Record<string, any> | null;
    /** @virtual */
    formula?: (string | Record<string, any> | string[]) | null;
}

/**
 * Output type for BuilderBatch.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface BuilderBatchOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `pending`
     * - index
     */
    status: 'pending' | 'processing' | 'done' | 'error' | 'cancelled';
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate: Moment;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
        /** While this batch is processing, this field is updated periodically with how many products have been processed */
        progress: number;
    } | null;
    /** - computed: default */
    name: string;
    /**
     * A descriptive name for the batch to display in the UI when the batch trigger is not a simple/single
     * formula (e.g. triggering a recompute for a resource).
     */
    description?: string | null;
    /**
     * When enabled, an email will be sent to the user that created this batch
     * - default: `true`
     */
    notifyByEmail: boolean;
    error?: string | null;
    errorStack?: string | null;
    saveToFile?: {
        /** When enabled, product data and artifacts will be stored to s3 and and s3Path will be created */
        enabled?: boolean | null;
        /** - default: `[]` */
        fields: Array<string>;
        allVariables?: boolean | null;
        /** - default: `jsonl` */
        format: BuilderBatchSaveToFileFormatEnum;
        /**
         * bucket/key
         * - computed: overwrite
         */
        readonly s3Path: string;
        /**
         * When true, filters output file to only include Pv2's that are (or would be) updated.
         * Otherwise, report file will include all Pv2's from the batch.
         */
        onlyIncludeUpdatedPv2s?: boolean | null;
    } | null;
    saveToBigQuery?: boolean | null;
    /**
     * Set to true to apply recomputations from the batch back to the database
     * - default: `false`
     */
    saveComputationsToPv2s: boolean;
    /** - default: `false` */
    cancellationRequested: boolean;
    /** - index */
    environment?: string | null;
    _query?: string | null;
    _runStats?: string | null;
    /** - computed: overwrite */
    readonly _formula: string;
    limit?: number | null;
    /** - default: `false` */
    includeArtifacts: boolean;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    query?: Record<string, any> | null;
    /** @virtual */
    runStats?: Record<string, any> | null;
    /** @virtual */
    formula: string | Record<string, any> | string[];
}

/**
 * Input type for CircanaBrandMapping.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface CircanaBrandMappingInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    dictBrand: string;
    /** - index */
    manuCode: string;
    /** - index */
    spinsBrand: string;
}

/**
 * Output type for CircanaBrandMapping.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface CircanaBrandMappingOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    dictBrand: string;
    /** - index */
    manuCode: string;
    /** - index */
    spinsBrand: string;
}

/**
 * Input type for CleansedData.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface CleansedDataInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    gtin?: string | null;
    identifiers?: {
        /** - default: `[]` */
        asins?: Array<string> | null;
        /** - default: `[]` */
        rivirIds?: Array<string> | null;
    } | null;
    discontinuedIdentifiers?: {
        /** - default: `[]` */
        asins?: Array<string> | null;
        /** - default: `[]` */
        rivirIds?: Array<string> | null;
    } | null;
    /** - default: `[]` */
    name?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    brand?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    manufacturer?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    description?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    category?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    subcategory?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    ingredientStatement?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    assetStoragePath?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    age?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    flavor?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    form?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    functionalIngredient?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    gender?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    healthFocus?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    itemDescription?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    packCount?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    productType?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    scent?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    size?: Array<CleansedDataPointStringInput> | null;
    /** - default: `[]` */
    unitOfMeasure?: Array<CleansedDataPointStringInput> | null;
    isGtinValid?: boolean | null;
    /** - default: `[]` */
    nutritionFacts?: Array<CleansedDataPointNutritionFactsInput> | null;
    /** - default: `[]` */
    supplementFacts?: Array<CleansedDataPointSupplementFactsInput> | null;
    /** - default: `[]` */
    servingInformation?: Array<CleansedDataPointServingInformationInput> | null;
    /** - default: `[]` */
    allergenInformation?: Array<CleansedDataPointAllergenInformationInput> | null;
    /** - default: `[]` */
    sourceSpecific?: Array<CleansedDataPointSourceSpecificInput> | null;
    /**
     * READONLY. The distinct "source" values across every data point on this record.
     * Denormalized so that "which records did source X touch?" is a single multikey
     * index lookup rather than an $or across every data point field.
     *
     * Recomputed in the pre.validate middleware, and written directly by
     * CleansedDataMongoUpdateMapper.kt in the pi-engine-dataflow repo.
     * - default: `[]`
     */
    sources?: Array<
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales'
    > | null;
    /**
     * READONLY. The distinct "ingestionEvent" values across every data point on this
     * record. Denormalized so that "which records did ingestion event Y touch?" is a
     * single multikey index lookup rather than an $or across every data point field.
     *
     * Recomputed in the pre.validate middleware, and written directly by
     * CleansedDataMongoUpdateMapper.kt in the pi-engine-dataflow repo.
     * - default: `[]`
     */
    ingestionEvents?: Array<Ref<'RawIngestionEvent'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for CleansedData.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface CleansedDataOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    gtin?: string | null;
    identifiers?: {
        /** - default: `[]` */
        asins: Array<string>;
        /** - default: `[]` */
        rivirIds: Array<string>;
    } | null;
    discontinuedIdentifiers?: {
        /** - default: `[]` */
        asins: Array<string>;
        /** - default: `[]` */
        rivirIds: Array<string>;
    } | null;
    /** - default: `[]` */
    name: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    brand: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    manufacturer: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    description: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    category: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    subcategory: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    ingredientStatement: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    assetStoragePath: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    age: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    flavor: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    form: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    functionalIngredient: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    gender: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    healthFocus: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    itemDescription: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    packCount: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    productType: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    scent: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    size: Array<CleansedDataPointStringDoc>;
    /** - default: `[]` */
    unitOfMeasure: Array<CleansedDataPointStringDoc>;
    isGtinValid?: boolean | null;
    /** - default: `[]` */
    nutritionFacts: Array<CleansedDataPointNutritionFactsDoc>;
    /** - default: `[]` */
    supplementFacts: Array<CleansedDataPointSupplementFactsDoc>;
    /** - default: `[]` */
    servingInformation: Array<CleansedDataPointServingInformationDoc>;
    /** - default: `[]` */
    allergenInformation: Array<CleansedDataPointAllergenInformationDoc>;
    /** - default: `[]` */
    sourceSpecific: Array<CleansedDataPointSourceSpecificDoc>;
    /**
     * READONLY. The distinct "source" values across every data point on this record.
     * Denormalized so that "which records did source X touch?" is a single multikey
     * index lookup rather than an $or across every data point field.
     *
     * Recomputed in the pre.validate middleware, and written directly by
     * CleansedDataMongoUpdateMapper.kt in the pi-engine-dataflow repo.
     * - default: `[]`
     */
    sources: Array<
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales'
    >;
    /**
     * READONLY. The distinct "ingestionEvent" values across every data point on this
     * record. Denormalized so that "which records did ingestion event Y touch?" is a
     * single multikey index lookup rather than an $or across every data point field.
     *
     * Recomputed in the pre.validate middleware, and written directly by
     * CleansedDataMongoUpdateMapper.kt in the pi-engine-dataflow repo.
     * - default: `[]`
     */
    ingestionEvents: Array<Ref<'RawIngestionEvent'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for ClientTrackerValue.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface ClientTrackerValueInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    spinsUpc: string;
    /** - default: `[]` */
    jiraTicket?: Array<string> | null;
    jiraClientName?: string | null;
    jiraAssignee?: string | null;
    attributeName: string;
    attributeValue: string;
    /** - default: `false` */
    clientValidatedCoding?: boolean | null;
    periodRelease?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for ClientTrackerValue.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface ClientTrackerValueOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    spinsUpc: string;
    /** - default: `[]` */
    jiraTicket: Array<string>;
    jiraClientName?: string | null;
    jiraAssignee?: string | null;
    attributeName: string;
    attributeValue: string;
    /** - default: `false` */
    clientValidatedCoding: boolean;
    periodRelease?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Company.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface CompanyInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    name: string;
    /**
     * - computed: overwrite
     * - index
     */
    slug?: string | null;
    /** - default: `[]` */
    nameAliases?: Array<string> | null;
    /** - index */
    type: 'brand' | 'broker' | 'manufacturer' | 'provider' | 'retailer' | 'distributor' | 'other';
    website?: string | null;
    email?: string | null;
    /** - default: `false` */
    emailVerified?: boolean | null;
    streetAddress?: string | null;
    phone?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    logo?: {
        small: string;
        large: string;
    } | null;
    primaryContact?: {
        name?: string | null;
        role?: string | null;
        email?: string | null;
        phone?: string | null;
    } | null;
    /**
     * - default: `0`
     * - computed: overwrite
     * - index
     */
    depth?: number | null;
    /** - index */
    parentCompany?: Ref<'Company'> | null;
    /** - default: `[]` */
    descendentCompanies?: Array<Ref<'Company'>> | null;
    /** - default: `[]` */
    ancestorCompanies?: Array<Ref<'Company'>> | null;
    /** For companies of type "brand", auto populates with the closest ancestor of type "manufacturer" */
    manufacturer?: Ref<'Company'> | null;
    contentSupplierSource?: string | null;
    digitalAssetManagementSystem?: string | null;
    globalLocationNumber?: string | null;
    /**
     * The task that updated the company.
     * - index
     */
    task?: Ref<'Task'> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Company.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface CompanyOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    name: string;
    /**
     * - computed: overwrite
     * - index
     */
    readonly slug: string;
    /** - default: `[]` */
    nameAliases: Array<string>;
    /** - index */
    type: 'brand' | 'broker' | 'manufacturer' | 'provider' | 'retailer' | 'distributor' | 'other';
    website?: string | null;
    email?: string | null;
    /** - default: `false` */
    emailVerified: boolean;
    streetAddress?: string | null;
    phone?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    logo?: {
        small: string;
        large: string;
    } | null;
    primaryContact?: {
        name?: string | null;
        role?: string | null;
        email?: string | null;
        phone?: string | null;
    } | null;
    /**
     * - default: `0`
     * - computed: overwrite
     * - index
     */
    readonly depth: number;
    /** - index */
    parentCompany?: Ref<'Company'> | null;
    /** - default: `[]` */
    descendentCompanies: Array<Ref<'Company'>>;
    /** - default: `[]` */
    ancestorCompanies: Array<Ref<'Company'>>;
    /** For companies of type "brand", auto populates with the closest ancestor of type "manufacturer" */
    manufacturer?: Ref<'Company'> | null;
    contentSupplierSource?: string | null;
    digitalAssetManagementSystem?: string | null;
    globalLocationNumber?: string | null;
    /**
     * The task that updated the company.
     * - index
     */
    task?: Ref<'Task'> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for CompanySignupRequest.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Stores the data for company requests
 */
export interface CompanySignupRequestInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    email: string;
    firstName: string;
    lastName: string;
    userTitle?: string | null;
    userCompany?: string | null;
    userPhone?: string | null;
    managerAdminInformation?: {
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        title?: string | null;
    } | null;
    legalCompanyName: string;
    /** - index */
    companyType:
        | 'broker'
        | 'distributor'
        | 'manufacturer_or_brand'
        | 'marketing_or_sales'
        | 'agency'
        | 'other'
        | 'retailer'
        | 'service_provider_or_app_developer';
    skuCount?: ('max20' | 'min20max100' | 'min100') | null;
    numSkusToManage?: number | null;
    sponsored?: boolean | null;
    contractPending?: boolean | null;
    readyForSetup?: boolean | null;
    listAllOwnedBrands?: string | null;
    companyAddress: string;
    companyAddress2?: string | null;
    companyCity: string;
    companyState?: string | null;
    companyZipCode?: string | null;
    adultBeverage?: boolean | null;
    planType?: ('basic' | 'complianceBasic' | 'pro' | 'enterprise') | null;
    retailerReferral?: string | null;
    planPromoCode?: string | null;
    partnerName?: string | null;
    domain?: Ref<'Domain'> | null;
    /**
     * - default: `waiting`
     * - index
     */
    status?: ('waiting' | 'done') | null;
    country?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for CompanySignupRequest.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Stores the data for company requests
 */
export interface CompanySignupRequestOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    email: string;
    firstName: string;
    lastName: string;
    userTitle?: string | null;
    userCompany?: string | null;
    userPhone?: string | null;
    managerAdminInformation?: {
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        title?: string | null;
    } | null;
    legalCompanyName: string;
    /** - index */
    companyType:
        | 'broker'
        | 'distributor'
        | 'manufacturer_or_brand'
        | 'marketing_or_sales'
        | 'agency'
        | 'other'
        | 'retailer'
        | 'service_provider_or_app_developer';
    skuCount?: ('max20' | 'min20max100' | 'min100') | null;
    numSkusToManage?: number | null;
    sponsored?: boolean | null;
    contractPending?: boolean | null;
    readyForSetup?: boolean | null;
    listAllOwnedBrands?: string | null;
    companyAddress: string;
    companyAddress2?: string | null;
    companyCity: string;
    companyState?: string | null;
    companyZipCode?: string | null;
    adultBeverage?: boolean | null;
    planType?: ('basic' | 'complianceBasic' | 'pro' | 'enterprise') | null;
    retailerReferral?: string | null;
    planPromoCode?: string | null;
    partnerName?: string | null;
    domain?: Ref<'Domain'> | null;
    /**
     * - default: `waiting`
     * - index
     */
    status: 'waiting' | 'done';
    country?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Config.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * A Config is a one off configuration object that is needed by one or more applications, but that is not needed to have its own collection.
 *
 * It encodes the unique key of the application and an arbitrary JSON value
 *
 * It's meant to be a permanent way of storing one-offs (more robust than redis),
 *  but less restrictive and easily accessible/query-able (than e.g. aws.SecretsManager).
 *
 * Example applications:
 *  - store which are the current active digitization stores
 *  - whitelist/blacklist queries for each partner for digitization
 */
export interface ConfigInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `0` */
    version?: number | null;
    description?: string | null;
    _value?: string | null;
    _valueJsonSchema?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    value?: (Record<string, any> | any[]) | null;
    /** @virtual */
    valueJsonSchema?: (Record<string, any> | any[]) | null;
}

/**
 * Output type for Config.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * A Config is a one off configuration object that is needed by one or more applications, but that is not needed to have its own collection.
 *
 * It encodes the unique key of the application and an arbitrary JSON value
 *
 * It's meant to be a permanent way of storing one-offs (more robust than redis),
 *  but less restrictive and easily accessible/query-able (than e.g. aws.SecretsManager).
 *
 * Example applications:
 *  - store which are the current active digitization stores
 *  - whitelist/blacklist queries for each partner for digitization
 */
export interface ConfigOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `0` */
    version: number;
    description?: string | null;
    _value: string;
    _valueJsonSchema?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    readonly validator?:
        | ((
              data: Record<string, any>,
              options?: { sanitize?: boolean },
          ) => { valid: boolean; errors: AjvError[] })
        | null;
    /** @virtual */
    value: Record<string, any> | any[];
    /** @virtual */
    valueJsonSchema?: (Record<string, any> | any[]) | null;
}

/**
 * Input type for DeleteHistory.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface DeleteHistoryInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    modelName: string;
    /** - index */
    modelID: string;
    payload: Record<string, any>;
    /** - index */
    user?: Ref<'User'> | null;
    /**
     * - default: `()`
     * - index
     */
    date?: Moment | null;
}

/**
 * Output type for DeleteHistory.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface DeleteHistoryOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    modelName: string;
    /** - index */
    modelID: string;
    payload: Record<string, any>;
    /** - index */
    user?: Ref<'User'> | null;
    /**
     * - default: `()`
     * - index
     */
    date: Moment;
}

/**
 * Input type for DigitizationUpcScan.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface DigitizationUpcScanInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    upc: string;
    originalUpc?: string | null;
    /** - index */
    domain: Ref<'Domain'>;
    /** - index */
    store?: string | null;
    /**
     * @deprecated In new records this should be handled by the createdBy tracking field
     * - index
     */
    user?: Ref<'User'> | null;
    /**
     * - default: `()`
     * - index
     */
    date?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for DigitizationUpcScan.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface DigitizationUpcScanOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    upc: string;
    originalUpc?: string | null;
    /** - index */
    domain: Ref<'Domain'>;
    /** - index */
    store?: string | null;
    /**
     * @deprecated In new records this should be handled by the createdBy tracking field
     * - index
     */
    user?: Ref<'User'> | null;
    /**
     * - default: `()`
     * - index
     */
    date: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for DigitizationUpdate.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface DigitizationUpdateInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    uid: string;
    /** - index */
    type: string;
    /** - index */
    upc: string;
    /**
     * - default: `()`
     * - index
     */
    date?: Moment | null;
    /** - index */
    user: Ref<'User'>;
    /** - index */
    domain: Ref<'Domain'>;
    /** - index */
    store?: string | null;
    payload: Record<string, any>;
    /** - index */
    pv2Id?: Ref<'Pv2'> | null;
    /** - default: `[]` */
    images?: Array<Ref<'Image'>> | null;
    /**
     * - computed: overwrite
     * - index
     */
    failed?: boolean | null;
    errorMessage?: string | null;
}

/**
 * Output type for DigitizationUpdate.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface DigitizationUpdateOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    uid: string;
    /** - index */
    type: string;
    /** - index */
    upc: string;
    /**
     * - default: `()`
     * - index
     */
    date: Moment;
    /** - index */
    user: Ref<'User'>;
    /** - index */
    domain: Ref<'Domain'>;
    /** - index */
    store?: string | null;
    payload: Record<string, any>;
    /** - index */
    pv2Id?: Ref<'Pv2'> | null;
    /** - default: `[]` */
    images: Array<Ref<'Image'>>;
    /**
     * - computed: overwrite
     * - index
     */
    readonly failed: boolean;
    errorMessage?: string | null;
}

/**
 * Input type for DigitizationUserStatus.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface DigitizationUserStatusInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * @deprecated In new records this should be covered by the createdBy tracking field
     * - index
     */
    user?: Ref<'User'> | null;
    app?: {
        /** - index */
        version: string;
        /** - index */
        build: number;
    } | null;
    device?: {
        /** - index */
        brand?: string | null;
        /** - index */
        modelName?: string | null;
        /** - index */
        deviceName?: string | null;
        /** - index */
        OS?: string | null;
        /** - index */
        OSVersion?: string | null;
    } | null;
    appState: Record<string, any>;
    photos: Record<string, any>;
    /** - index */
    force?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for DigitizationUserStatus.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface DigitizationUserStatusOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * @deprecated In new records this should be covered by the createdBy tracking field
     * - index
     */
    user?: Ref<'User'> | null;
    app?: {
        /** - index */
        version: string;
        /** - index */
        build: number;
    } | null;
    device?: {
        /** - index */
        brand?: string | null;
        /** - index */
        modelName?: string | null;
        /** - index */
        deviceName?: string | null;
        /** - index */
        OS?: string | null;
        /** - index */
        OSVersion?: string | null;
    } | null;
    appState: Record<string, any>;
    photos: Record<string, any>;
    /** - index */
    force?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Domain.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface DomainInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `brand` */
    type?:
        | (
              | 'brand'
              | 'third_party'
              | 'retailer'
              | 'manufacturer_or_brand'
              | 'broker'
              | 'distributor'
              | 'marketing_or_sales_agency'
              | 'service_provider_or_app_developer'
              | 'other'
          )
        | null;
    /** - index */
    nucleusRetailerId?: number | null;
    /**
     * Domain membership level
     * - basic: No write access
     * - pro: Write access
     * - enterprise: Write access
     * - default: `basic`
     * - index
     */
    membership?: DomainMembershipEnum | null;
    /**
     * - default: `false`
     * - index
     */
    hasManagerAccess?: boolean | null;
    /**
     * - default: `false`
     * - index
     */
    hasDigitizationAccess?: boolean | null;
    /** - default: `whitelist` */
    digitizationMode?: DomainDigitizationModeEnum | null;
    /** Identifier prefix for use in generation of Pv2.identifiers.hash field */
    identifierPrefix?: string | null;
    /**
     * Human-readable description for partner identifiers associated with domain for use
     * in the UI (e.g. "TCIN" for Target or "ASIN" for Amazon)
     */
    identifierName?: string | null;
    /**
     * - default: `global`
     * - index
     */
    productExclusivityMode?: ('global' | 'retailer') | null;
    planPromoCode?: string | null;
    estimatedSkuCount?: ('max20' | 'min20max100' | 'min100') | null;
    numSkusToManage?: number | null;
    partnerName?: string | null;
    referredByRetailer?: string | null;
    manufactureOrDistributeAlcoholInWF?: boolean | null;
    sponsored?: boolean | null;
    contractPending?: boolean | null;
    readyForSetup?: boolean | null;
    listAllOwnedBrands?: string | null;
    /** - default: `[]` */
    users?: Array<DomainUserInput> | null;
    /** - default: `[]` */
    companies?: Array<DomainCompanyInput> | null;
    /** - index */
    companyType?:
        | (
              | 'broker'
              | 'distributor'
              | 'manufacturer_or_brand'
              | 'marketing_or_sales'
              | 'agency'
              | 'other'
              | 'retailer'
              | 'service_provider_or_app_developer'
          )
        | null;
    /** - default: `[]` */
    taxonomies?: Array<DomainTaxonomyInput> | null;
    legalName?: string | null;
    acceptedTOS?: {
        user: Ref<'User'>;
        /**
         * - default: `()`
         * - index
         */
        date?: Moment | null;
    } | null;
    /** - default: `{"dataAndImages":true,"dataOnly":false}` */
    dataAccess?: {
        dataAndImages: boolean;
        dataOnly: boolean;
    } | null;
    contract?: {
        /**
         * - default: `()`
         * - index
         */
        startDate?: Moment | null;
        lengthInDays?: number | null;
        autoRenewal?: boolean | null;
        /** - default: `90` */
        renewalNotificationPeriodInDays?: number | null;
        feePerYear?: number | null;
        additionalSkuFeePerYear?: number | null;
        /** - default: `null` */
        trialExpirationDate?: Moment | null;
        /** - default: `undefined` */
        contractedSkus?: number | null;
    } | null;
    mailingAddress?: {
        street?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
    } | null;
    billingAddress?: {
        street?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
    } | null;
    primaryContact?: {
        name: string;
        title?: string | null;
        email: string;
        phone?: string | null;
    } | null;
    accountOwner?: {
        name?: string | null;
        title?: string | null;
        email: string;
        phone?: string | null;
    } | null;
    /** - default: `[]` */
    documents?: Array<{
        /**
         * - computed: default
         * - index
         */
        _id?: any | null;
        name: string;
        s3Key: string;
        fileName: string;
        fileSizeMb: number;
        /** - default: `()` */
        uploadedDate?: Moment | null;
        uploadedBy: Ref<'User'>;
    }> | null;
    sftp?: {
        username: string;
        s3Path: string;
        /**
         * - default: `()`
         * - computed: default
         */
        createdDate?: Moment | null;
    } | null;
    pv2CustomFieldPrimary?: Ref<'Pv2CustomFieldConfig'> | null;
    /** - default: `[]` */
    pv2CustomFields?: Array<Ref<'Pv2CustomFieldConfig'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Domain.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface DomainOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `brand` */
    type:
        | 'brand'
        | 'third_party'
        | 'retailer'
        | 'manufacturer_or_brand'
        | 'broker'
        | 'distributor'
        | 'marketing_or_sales_agency'
        | 'service_provider_or_app_developer'
        | 'other';
    /** - index */
    nucleusRetailerId?: number | null;
    /**
     * Domain membership level
     * - basic: No write access
     * - pro: Write access
     * - enterprise: Write access
     * - default: `basic`
     * - index
     */
    membership: DomainMembershipEnum;
    /**
     * - default: `false`
     * - index
     */
    hasManagerAccess: boolean;
    /**
     * - default: `false`
     * - index
     */
    hasDigitizationAccess: boolean;
    /** - default: `whitelist` */
    digitizationMode: DomainDigitizationModeEnum;
    /** Identifier prefix for use in generation of Pv2.identifiers.hash field */
    identifierPrefix?: string | null;
    /**
     * Human-readable description for partner identifiers associated with domain for use
     * in the UI (e.g. "TCIN" for Target or "ASIN" for Amazon)
     */
    identifierName?: string | null;
    /**
     * - default: `global`
     * - index
     */
    productExclusivityMode: 'global' | 'retailer';
    planPromoCode?: string | null;
    estimatedSkuCount?: ('max20' | 'min20max100' | 'min100') | null;
    numSkusToManage?: number | null;
    partnerName?: string | null;
    referredByRetailer?: string | null;
    manufactureOrDistributeAlcoholInWF?: boolean | null;
    sponsored?: boolean | null;
    contractPending?: boolean | null;
    readyForSetup?: boolean | null;
    listAllOwnedBrands?: string | null;
    /** - default: `[]` */
    users: Array<DomainUserDoc>;
    /** - default: `[]` */
    companies: Array<DomainCompanyDoc>;
    /** - index */
    companyType?:
        | (
              | 'broker'
              | 'distributor'
              | 'manufacturer_or_brand'
              | 'marketing_or_sales'
              | 'agency'
              | 'other'
              | 'retailer'
              | 'service_provider_or_app_developer'
          )
        | null;
    /** - default: `[]` */
    taxonomies: Array<DomainTaxonomyDoc>;
    legalName?: string | null;
    acceptedTOS?: {
        user: Ref<'User'>;
        /**
         * - default: `()`
         * - index
         */
        date: Moment;
    } | null;
    /** - default: `{"dataAndImages":true,"dataOnly":false}` */
    dataAccess: {
        dataAndImages: boolean;
        dataOnly: boolean;
    };
    contract?: {
        /**
         * - default: `()`
         * - index
         */
        startDate: Moment;
        lengthInDays?: number | null;
        autoRenewal?: boolean | null;
        /** - default: `90` */
        renewalNotificationPeriodInDays: number;
        feePerYear?: number | null;
        additionalSkuFeePerYear?: number | null;
        /** - default: `null` */
        trialExpirationDate?: Moment | null;
        /** - default: `undefined` */
        contractedSkus?: number | null;
    } | null;
    mailingAddress?: {
        street?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
    } | null;
    billingAddress?: {
        street?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
    } | null;
    primaryContact?: {
        name: string;
        title?: string | null;
        email: string;
        phone?: string | null;
    } | null;
    accountOwner?: {
        name?: string | null;
        title?: string | null;
        email: string;
        phone?: string | null;
    } | null;
    /** - default: `[]` */
    documents: Array<{
        /**
         * - computed: default
         * - index
         */
        readonly _id: ObjectId | string;
        name: string;
        s3Key: string;
        fileName: string;
        fileSizeMb: number;
        /** - default: `()` */
        uploadedDate: Moment;
        uploadedBy: Ref<'User'>;
    }>;
    sftp?: {
        username: string;
        s3Path: string;
        /**
         * - default: `()`
         * - computed: default
         */
        createdDate: Moment;
    } | null;
    pv2CustomFieldPrimary?: Ref<'Pv2CustomFieldConfig'> | null;
    /** - default: `[]` */
    pv2CustomFields: Array<Ref<'Pv2CustomFieldConfig'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for FeatureFlagConfiguration.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface FeatureFlagConfigurationInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    envName: string;
    featureFlag: 'dummy';
    enabled: boolean;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for FeatureFlagConfiguration.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface FeatureFlagConfigurationOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    envName: string;
    featureFlag: 'dummy';
    enabled: boolean;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Form.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Stores forms created via the admin (v2) form builder
 *
 * Rendered forms are used in data entry tasks and are distributed via Tasker to Mturk or internally
 */
export interface FormInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * - default: `0`
     * - computed: overwrite
     */
    version?: number | null;
    description?: string | null;
    /**
     * Location in S3 where the value is stored ("Bucket/Key")
     *
     * Form value JSON is fetched via the "getConfig()" method or the "value" virtual type in graphql
     *
     * The format of this field is `<Bucket>/<s3Prefix>/forms/<_id>/<_id>-v<version>.json`
     * - computed: overwrite
     * - index
     * - unique
     */
    s3Path?: string | null;
    /** - index */
    sideComponent: 'none' | 'imageViewer' | 'iframe';
    /** - default: `[]` */
    dataRequirements?: Array<DataRequirementInput> | null;
    /** - default: `[]` */
    tags?: Array<string> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /**
     * Virtual to use when assigning a new JSON structure to this form
     *
     * When changed, if it's different than the existing value, the `doc.version` will be incremented and the new value will be uploaded to S3
     *
     * @virtual
     */
    config?: Record<string, any> | null;
}

/**
 * Output type for Form.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Stores forms created via the admin (v2) form builder
 *
 * Rendered forms are used in data entry tasks and are distributed via Tasker to Mturk or internally
 */
export interface FormOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * - default: `0`
     * - computed: overwrite
     */
    readonly version: number;
    description?: string | null;
    /**
     * Location in S3 where the value is stored ("Bucket/Key")
     *
     * Form value JSON is fetched via the "getConfig()" method or the "value" virtual type in graphql
     *
     * The format of this field is `<Bucket>/<s3Prefix>/forms/<_id>/<_id>-v<version>.json`
     * - computed: overwrite
     * - index
     * - unique
     */
    readonly s3Path: string;
    /** - index */
    sideComponent: 'none' | 'imageViewer' | 'iframe';
    /** - default: `[]` */
    dataRequirements: Array<DataRequirementOutput>;
    /** - default: `[]` */
    tags: Array<string>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /**
     * Virtual to use when assigning a new JSON structure to this form
     *
     * When changed, if it's different than the existing value, the `doc.version` will be incremented and the new value will be uploaded to S3
     *
     * @virtual
     */
    config?: Record<string, any> | null;
}

/**
 * Input type for FormInstruction.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface FormInstructionInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    form?: Ref<'Form'> | null;
    /** - index */
    name: string;
    structure: Record<string, any>;
    /** - computed: overwrite */
    s3Path?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for FormInstruction.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface FormInstructionOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    form?: Ref<'Form'> | null;
    /** - index */
    name: string;
    structure: Record<string, any>;
    /** - computed: overwrite */
    readonly s3Path: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Formula.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface FormulaInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `0`
     * - computed: default
     */
    version?: number | null;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    /** - default: `[]` */
    fields?: Array<string> | null;
    /**
     * - default: `false`
     * - index
     */
    isPublic?: boolean | null;
    /**
     * - default: `false`
     * - index
     */
    runInPv2Middleware?: boolean | null;
    filter?: string | null;
    structure: string;
    functions?: string | null;
    /** - default: `[]` */
    changelog?: Array<{
        /** - computed: default */
        version?: number | null;
        text: string;
    }> | null;
    /**
     * Attribute types written or cleared by this formula
     * - default: `[]`
     * - computed: overwrite
     * - index
     */
    outputAttributeTypes?: Array<string> | null;
    /**
     * FormulaResource _ids read by this formula
     * - computed: overwrite
     */
    inputResources?: {
        /**
         * Formula resources read directly by this formula
         * - default: `[]`
         */
        direct?: Array<Ref<'FormulaResource'>> | null;
        /**
         * Formula resources referenced by way of formula imports
         * - default: `[]`
         */
        indirect?: Array<Ref<'FormulaResource'>> | null;
    } | null;
    /**
     * Attribute types read by this formula
     * - computed: overwrite
     */
    inputAttributeTypes?: {
        /**
         * Attribute types read directly by this formula
         * - default: `[]`
         */
        direct?: Array<string> | null;
        /**
         * Attribute types referenced by way of formula imports
         * - default: `[]`
         */
        indirect?: Array<string> | null;
    } | null;
    /**
     * Top-level product fields read by this formula
     * - computed: overwrite
     */
    inputProductFields?: {
        /**
         * Builder product fields read directly by this formula
         * - default: `[]`
         */
        direct?: Array<string> | null;
        /**
         * Builder product fields referenced by way of formula imports
         * - default: `[]`
         */
        indirect?: Array<string> | null;
    } | null;
    /**
     * Top-level product fields read by this formula
     * - computed: overwrite
     */
    inputCleansedDataPoints?: {
        /**
         * Builder product fields read directly by this formula
         * - default: `[]`
         */
        direct?: Array<string> | null;
        /**
         * Builder product fields referenced by way of formula imports
         * - default: `[]`
         */
        indirect?: Array<string> | null;
    } | null;
    /**
     * Client tracker data points read by this formula
     * - computed: overwrite
     */
    inputClientTrackerAttributes?: {
        /**
         * Client tracker attributes read directly by this formula
         * - default: `[]`
         */
        direct?: Array<string> | null;
        /**
         * Client tracker attributes referenced by way of formula imports
         * - default: `[]`
         */
        indirect?: Array<string> | null;
    } | null;
    /**
     * Formulas that are referenced by this formula
     * - default: `[]`
     * - computed: overwrite
     */
    referencedFormulas?: Array<{
        /** _id of the referenced formula */
        formula: Ref<'Formula'>;
        /** Convenience field showing the name of the referenced formula, could be removed once QA review is complete */
        name?: string | null;
        /**
         * List of variables imported from the referenced formula
         * - default: `[]`
         */
        imports?: Array<string> | null;
    }> | null;
    /**
     * Middleware formulas that write attributes read by this formula.
     * (Only populated if runInPv2Middleware is true)
     * - default: `[]`
     * - computed: overwrite
     */
    affectedByFormulas?: Array<{
        formula: Ref<'Formula'>;
        name?: string | null;
    }> | null;
    /**
     * Attribute types exported as variables for use in other formulas
     * - default: `[]`
     * - computed: overwrite
     */
    exports?: Array<{
        /** Name of the exported variable */
        name: string;
        /**
         * Attribute types affecting that variable
         * - default: `[]`
         */
        attributeTypes?: Array<string> | null;
        /**
         * Top-level product fields affecting that variable
         * - default: `[]`
         */
        productFields?: Array<string> | null;
        /**
         * Formula resources affecting that variable
         * - default: `[]`
         */
        resources?: Array<Ref<'FormulaResource'>> | null;
        /**
         * Cleansed data points affecting that variable
         * - default: `[]`
         */
        cleansedDataPoints?: Array<string> | null;
        /**
         * Client tracker attributes affecting that variable
         * - default: `[]`
         */
        clientTrackerAttributes?: Array<string> | null;
    }> | null;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Formula.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface FormulaOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `0`
     * - computed: default
     */
    version: number;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    /** - default: `[]` */
    fields: Array<string>;
    /**
     * - default: `false`
     * - index
     */
    isPublic: boolean;
    /**
     * - default: `false`
     * - index
     */
    runInPv2Middleware: boolean;
    filter?: string | null;
    structure: string;
    functions?: string | null;
    /** - default: `[]` */
    changelog: Array<{
        /** - computed: default */
        version: number;
        text: string;
    }>;
    /**
     * Attribute types written or cleared by this formula
     * - default: `[]`
     * - computed: overwrite
     * - index
     */
    readonly outputAttributeTypes: Array<string>;
    /**
     * FormulaResource _ids read by this formula
     * - computed: overwrite
     */
    readonly inputResources: {
        /**
         * Formula resources read directly by this formula
         * - default: `[]`
         */
        direct: Array<Ref<'FormulaResource'>>;
        /**
         * Formula resources referenced by way of formula imports
         * - default: `[]`
         */
        indirect: Array<Ref<'FormulaResource'>>;
    };
    /**
     * Attribute types read by this formula
     * - computed: overwrite
     */
    readonly inputAttributeTypes: {
        /**
         * Attribute types read directly by this formula
         * - default: `[]`
         */
        direct: Array<string>;
        /**
         * Attribute types referenced by way of formula imports
         * - default: `[]`
         */
        indirect: Array<string>;
    };
    /**
     * Top-level product fields read by this formula
     * - computed: overwrite
     */
    readonly inputProductFields: {
        /**
         * Builder product fields read directly by this formula
         * - default: `[]`
         */
        direct: Array<string>;
        /**
         * Builder product fields referenced by way of formula imports
         * - default: `[]`
         */
        indirect: Array<string>;
    };
    /**
     * Top-level product fields read by this formula
     * - computed: overwrite
     */
    readonly inputCleansedDataPoints: {
        /**
         * Builder product fields read directly by this formula
         * - default: `[]`
         */
        direct: Array<string>;
        /**
         * Builder product fields referenced by way of formula imports
         * - default: `[]`
         */
        indirect: Array<string>;
    };
    /**
     * Client tracker data points read by this formula
     * - computed: overwrite
     */
    readonly inputClientTrackerAttributes: {
        /**
         * Client tracker attributes read directly by this formula
         * - default: `[]`
         */
        direct: Array<string>;
        /**
         * Client tracker attributes referenced by way of formula imports
         * - default: `[]`
         */
        indirect: Array<string>;
    };
    /**
     * Formulas that are referenced by this formula
     * - default: `[]`
     * - computed: overwrite
     */
    readonly referencedFormulas: Array<{
        /** _id of the referenced formula */
        formula: Ref<'Formula'>;
        /** Convenience field showing the name of the referenced formula, could be removed once QA review is complete */
        name?: string | null;
        /**
         * List of variables imported from the referenced formula
         * - default: `[]`
         */
        imports: Array<string>;
    }>;
    /**
     * Middleware formulas that write attributes read by this formula.
     * (Only populated if runInPv2Middleware is true)
     * - default: `[]`
     * - computed: overwrite
     */
    readonly affectedByFormulas: Array<{
        formula: Ref<'Formula'>;
        name?: string | null;
    }>;
    /**
     * Attribute types exported as variables for use in other formulas
     * - default: `[]`
     * - computed: overwrite
     */
    readonly exports: Array<{
        /** Name of the exported variable */
        name: string;
        /**
         * Attribute types affecting that variable
         * - default: `[]`
         */
        attributeTypes: Array<string>;
        /**
         * Top-level product fields affecting that variable
         * - default: `[]`
         */
        productFields: Array<string>;
        /**
         * Formula resources affecting that variable
         * - default: `[]`
         */
        resources: Array<Ref<'FormulaResource'>>;
        /**
         * Cleansed data points affecting that variable
         * - default: `[]`
         */
        cleansedDataPoints: Array<string>;
        /**
         * Client tracker attributes affecting that variable
         * - default: `[]`
         */
        clientTrackerAttributes: Array<string>;
    }>;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for FormulaResource.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface FormulaResourceInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `0`
     * - computed: default
     */
    version?: number | null;
    /**
     * - default: `list`
     * - index
     */
    type?: ('list' | 'table') | null;
    config?: Record<string, any> | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    /**
     * - computed: overwrite
     * - index
     * - unique
     */
    slug?: string | null;
    description?: string | null;
    value?: string | null;
    /** - default: `[]` */
    children?: Array<Ref<'FormulaResource'>> | null;
    /** - default: `[]` */
    descendents?: Array<Ref<'FormulaResource'>> | null;
    /**
     * - computed: overwrite
     * - index
     */
    totalChildren?: number | null;
    /**
     * - computed: overwrite
     * - index
     */
    ownItems?: number | null;
    /**
     * - computed: overwrite
     * - index
     */
    totalItems?: number | null;
    /**
     * - computed: overwrite
     * - unique
     */
    s3Path?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    valueJSON?: Array<string | Record<string, any>> | null;
}

/**
 * Output type for FormulaResource.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface FormulaResourceOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `0`
     * - computed: default
     */
    version: number;
    /**
     * - default: `list`
     * - index
     */
    type: 'list' | 'table';
    config?: Record<string, any> | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    /**
     * - computed: overwrite
     * - index
     * - unique
     */
    readonly slug: string;
    description?: string | null;
    value: string;
    /** - default: `[]` */
    children: Array<Ref<'FormulaResource'>>;
    /** - default: `[]` */
    descendents: Array<Ref<'FormulaResource'>>;
    /**
     * - computed: overwrite
     * - index
     */
    readonly totalChildren: number;
    /**
     * - computed: overwrite
     * - index
     */
    readonly ownItems: number;
    /**
     * - computed: overwrite
     * - index
     */
    readonly totalItems: number;
    /**
     * - computed: overwrite
     * - unique
     */
    readonly s3Path: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    valueJSON: Array<string | Record<string, any>>;
}

/**
 * Input type for GS1TaxonomyMapping.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Stores the taxonomy ref id and gpcCode to map taxonomies for Metro GS1 ingestion
 */
export interface GS1TaxonomyMappingInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    taxonomyId: Ref<'Taxonomy'>;
    /** - unique */
    gpcCode: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for GS1TaxonomyMapping.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Stores the taxonomy ref id and gpcCode to map taxonomies for Metro GS1 ingestion
 */
export interface GS1TaxonomyMappingOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    taxonomyId: Ref<'Taxonomy'>;
    /** - unique */
    gpcCode: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for GcpScriptLog.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface GcpScriptLogInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    executionId: string;
    executionUrl: string;
    namespace: string;
    /** - default: `()` */
    timestamp?: Moment | null;
    userId: string;
}

/**
 * Output type for GcpScriptLog.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface GcpScriptLogOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    executionId: string;
    executionUrl: string;
    namespace: string;
    /** - default: `()` */
    timestamp: Moment;
    userId: string;
}

/**
 * Input type for HierarchyAllowedValues.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface HierarchyAllowedValuesInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    spinsAttributeTypeId: Ref<'SpinsAttributeType'>;
    /** - index */
    hierarchyId: Ref<'Taxonomy'>;
    /** - default: `[]` */
    values?: Array<string> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for HierarchyAllowedValues.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface HierarchyAllowedValuesOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    spinsAttributeTypeId: Ref<'SpinsAttributeType'>;
    /** - index */
    hierarchyId: Ref<'Taxonomy'>;
    /** - default: `[]` */
    values: Array<string>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for HierarchyMapping.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface HierarchyMappingInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    circanaKeyCat: string;
    fallbackTaxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `[]` */
    rules?: Array<HierarchyMappingRuleInput> | null;
    /**
     * All taxonomies directly output by any mapping rules or fallback.
     * - default: `[]`
     */
    taxonomies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * All parent/ancestor taxonomies (e.g. department and category) for taxonomies
     * output by this mapping.
     * - default: `[]`
     */
    parentTaxonomies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for HierarchyMapping.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface HierarchyMappingOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    circanaKeyCat: string;
    fallbackTaxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `[]` */
    rules: Array<HierarchyMappingRuleDoc>;
    /**
     * All taxonomies directly output by any mapping rules or fallback.
     * - default: `[]`
     */
    taxonomies: Array<Ref<'Taxonomy'>>;
    /**
     * All parent/ancestor taxonomies (e.g. department and category) for taxonomies
     * output by this mapping.
     * - default: `[]`
     */
    parentTaxonomies: Array<Ref<'Taxonomy'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Image.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface ImageInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `glamor`
     * - index
     */
    type?: ('glamor' | 'closeup') | null;
    /**
     * - default: `raw`
     * - index
     */
    status?:
        | ('done' | 'pending' | 'pending_review' | 'processing' | 'raw' | 'failed' | 'outdated')
        | null;
    /** @deprecated legacy */
    key?: string | null;
    /** - index */
    side: string;
    /** - index */
    source?: string | null;
    name?: string | null;
    downloaded?: {
        user: Ref<'User'>;
        /** - default: `()` */
        timestamp?: Moment | null;
    } | null;
    uploaded?: {
        user: Ref<'User'>;
        /** - default: `()` */
        timestamp?: Moment | null;
    } | null;
    /** - default: `[]` */
    scannedBarcodes?: Array<ScannedBarcodesInput> | null;
    /** - default: `[]` */
    urls?: Array<ImageUrlInput> | null;
    /** - index */
    rejectionReason?:
        | (
              | 'White_Balance_Issue'
              | 'Cropping_Issue'
              | 'Exposure_Issue'
              | 'Image_Orientation_Issue'
              | 'other'
          )
        | null;
    /** - default: `()` */
    acceptedTimestamp?: Moment | null;
    /**
     * Image Id reference to the original image the current image will replace during the image processing pipeline process
     * - index
     */
    overrides?: Ref<'Image'> | null;
    /**
     * - default: `false`
     * - index
     */
    isInImageProcessingQueue?: boolean | null;
    /**
     * - default: `100`
     * - computed: overwrite
     * - index
     */
    pv2ProcessingPriority?: number | null;
    /** - index */
    pv2?: Ref<'Pv2'> | null;
    /**
     * Raw URL for images with source: digitization-app
     * - default: `[]`
     */
    digitizationOriginalUrls?: Array<ImageUrlInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Image.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface ImageOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `glamor`
     * - index
     */
    type: 'glamor' | 'closeup';
    /**
     * - default: `raw`
     * - index
     */
    status: 'done' | 'pending' | 'pending_review' | 'processing' | 'raw' | 'failed' | 'outdated';
    /** @deprecated legacy */
    key?: string | null;
    /** - index */
    side: string;
    /** - index */
    source?: string | null;
    name?: string | null;
    downloaded?: {
        user: Ref<'User'>;
        /** - default: `()` */
        timestamp: Moment;
    } | null;
    uploaded?: {
        user: Ref<'User'>;
        /** - default: `()` */
        timestamp: Moment;
    } | null;
    /** - default: `[]` */
    scannedBarcodes: Array<ScannedBarcodesDoc>;
    /** - default: `[]` */
    urls: Array<ImageUrlDoc>;
    /** - index */
    rejectionReason?:
        | (
              | 'White_Balance_Issue'
              | 'Cropping_Issue'
              | 'Exposure_Issue'
              | 'Image_Orientation_Issue'
              | 'other'
          )
        | null;
    /** - default: `()` */
    acceptedTimestamp: Moment;
    /**
     * Image Id reference to the original image the current image will replace during the image processing pipeline process
     * - index
     */
    overrides?: Ref<'Image'> | null;
    /**
     * - default: `false`
     * - index
     */
    isInImageProcessingQueue: boolean;
    /**
     * - default: `100`
     * - computed: overwrite
     * - index
     */
    readonly pv2ProcessingPriority: number;
    /** - index */
    pv2?: Ref<'Pv2'> | null;
    /**
     * Raw URL for images with source: digitization-app
     * - default: `[]`
     */
    digitizationOriginalUrls: Array<ImageUrlDoc>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    readonly angle: string;
    /** @virtual */
    readonly mainUrl?: ImageUrlDoc | null;
    /** @virtual */
    readonly thumbnailUrl?: ImageUrlDoc | null;
    /** @virtual */
    readonly croppedUrl?: ImageUrlDoc | null;
}

/**
 * Input type for Ingestion.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Retains details about Ingestions
 */
export interface IngestionInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    retailerId: number;
    /**
     * - default: `pending`
     * - index
     */
    status?: ('pending' | 'processing' | 'done' | 'error') | null;
    type: 'items' | 'stores' | 'sales' | 'product';
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate?: Moment | null;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
    } | null;
    message?: {
        projectId: string;
        topicId: string;
        domain: string;
        process: string;
        fileLocation: string;
        completionDate: Moment;
        latestEffectiveDate: string;
    } | null;
    statsItems?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
        whitelisted: number;
        whitelistedPrivateLabel: number;
        unique: number;
        duplicates: number;
        /** - default: `[]` */
        duplicateItemCodes?: Array<string> | null;
    } | null;
    statsStores?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
    } | null;
    statsSales?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
    } | null;
    /** - computed: default */
    name?: string | null;
    internalError?: string | null;
    _query?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    query?: Record<string, any> | null;
}

/**
 * Output type for Ingestion.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Retains details about Ingestions
 */
export interface IngestionOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    retailerId: number;
    /**
     * - default: `pending`
     * - index
     */
    status: 'pending' | 'processing' | 'done' | 'error';
    type: 'items' | 'stores' | 'sales' | 'product';
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate: Moment;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
    } | null;
    message?: {
        projectId: string;
        topicId: string;
        domain: string;
        process: string;
        fileLocation: string;
        completionDate: Moment;
        latestEffectiveDate: string;
    } | null;
    statsItems?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
        whitelisted: number;
        whitelistedPrivateLabel: number;
        unique: number;
        duplicates: number;
        /** - default: `[]` */
        duplicateItemCodes: Array<string>;
    } | null;
    statsStores?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
    } | null;
    statsSales?: {
        rows: number;
        created: number;
        updated: number;
        ignored: number;
    } | null;
    /** - computed: default */
    name: string;
    internalError?: string | null;
    _query?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    query?: Record<string, any> | null;
}

/**
 * Input type for Jwt.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface JwtInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /**
     * - index
     * - unique
     */
    token: string;
    /** - index */
    valid: boolean;
    expiresAt: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Jwt.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface JwtOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /**
     * - index
     * - unique
     */
    token: string;
    /** - index */
    valid: boolean;
    expiresAt: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for LockedValues.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface LockedValuesInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - unique */
    gtin: string;
    pv2Override?: Ref<'Pv2'> | null;
    /**
     * The spinsUpc of the Pv2 in "pv2Override", or an empty string if there is no override
     * - index
     */
    spinsUpc?: string | null;
    brand?: string | null;
    department?: string | null;
    category?: string | null;
    subcategory?: string | null;
    maskedBrand?: string | null;
    packCount?: string | null;
    privateLabelConventional?: string | null;
    size?: string | null;
    unitOfMeasurement?: string | null;
    animalType?: string | null;
    flavor?: string | null;
    form?: string | null;
    packagingTypePrimary?: string | null;
    productType?: string | null;
    storage?: string | null;
    chocolateType?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for LockedValues.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface LockedValuesOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - unique */
    gtin: string;
    pv2Override?: Ref<'Pv2'> | null;
    /**
     * The spinsUpc of the Pv2 in "pv2Override", or an empty string if there is no override
     * - index
     */
    spinsUpc?: string | null;
    brand?: string | null;
    department?: string | null;
    category?: string | null;
    subcategory?: string | null;
    maskedBrand?: string | null;
    packCount?: string | null;
    privateLabelConventional?: string | null;
    size?: string | null;
    unitOfMeasurement?: string | null;
    animalType?: string | null;
    flavor?: string | null;
    form?: string | null;
    packagingTypePrimary?: string | null;
    productType?: string | null;
    storage?: string | null;
    chocolateType?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for MaskedUpc.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface MaskedUpcInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    upc: string;
    /**
     * READONLY.
     * This will computed on pre.validate. It will always be the max masked upc + 1;
     * - computed: overwrite
     */
    maskedUpc?: string | null;
    gtin: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for MaskedUpc.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface MaskedUpcOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    upc: string;
    /**
     * READONLY.
     * This will computed on pre.validate. It will always be the max masked upc + 1;
     * - computed: overwrite
     */
    readonly maskedUpc: string;
    gtin: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for MturkHIT.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface MturkHITInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * temporary flag for the few weeks while we have both mturk pipelines running in the same time. once legacy mturk is deprecated this can be removed
     * - computed: overwrite
     * - index
     */
    isV2?: boolean | null;
    /** - index */
    taskDefinition: Ref<'TaskDefinition'>;
    /** - index */
    task: Ref<'Task'>;
    /** - index */
    status: 'processing' | 'skip' | 'done' | 'error' | 'expired';
    error?: string | null;
    config?: Record<string, any> | null;
    result?: Record<string, any> | null;
    stats?: Record<string, any> | null;
    /** - default: `false` */
    empty?: boolean | null;
    /** - default: `[]` */
    assignmentList?: Array<{
        data: Record<string, any>;
        weight?: number | null;
        /** - index */
        AssignmentId: string;
        /** - index */
        WorkerId: string;
        AssignmentStatus?: string | null;
        AutoApprovalTime?: string | null;
        AcceptTime?: string | null;
        SubmitTime?: string | null;
        ApprovalTime?: string | null;
        Reason?: string | null;
    }> | null;
    /**
     * The full cost of this task, including amazon's cut
     * - default: `0`
     * - index
     */
    cost?: number | null;
    /**
     * How many workers have to agree in order for this task to validate successfully.
     *
     * When majorityScore === 1 no consensus validation will be performed
     *
     * When majorityScore > 1, the task will start with majorityScore workers and continue asking for more workers until majorityScore workers agree (up to the maxAllowedAssignments limit)
     * - default: `1`
     * - index
     */
    majorityScore?: number | null;
    /**
     * When majorityScore > 1 this field controls the maximum number of workers that will be added onto a task to attempt to get a majority.
     *
     * The task is considered failed if more workers are needed past this point
     * - default: `5`
     */
    maxAllowedAssignments?: number | null;
    invalidAssignments?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** - default: `[]` */
    workers?: Array<{
        /**
         * - computed: overwrite
         * - index
         */
        mturkWorker?: Ref<'MturkWorker'> | null;
        /** - index */
        AssignmentId: string;
        /** - index */
        WorkerId: string;
        /** - index */
        bonus: number;
        /** - index */
        fullBonus: number;
        /** - index */
        score: number;
        info?: Record<string, any> | null;
        /** - index */
        rejected?: string | null;
        /** - index */
        skipped?: string | null;
        /**
         * Feedback generated from the form-builder package that is used to display on the mturk feedback page. Every score reduction will be accompanied by an issue entry
         * - default: `[]`
         */
        issues?: Array<Record<string, any>> | null;
        /**
         * When a worker sends us a message disputing some fields, and they turn out to be currect, we set isCorrect on the MturkMessage, and mark both the message and the worker as isConsolidated to show that these issues have overwritten the result
         *
         * NOTE: Consolidation is not yet implemented in mturk v2
         * - index
         */
        isConsolidated?: boolean | null;
    }> | null;
    /** - index */
    HITId: string;
    /** - index */
    HITTypeId: string;
    /** - index */
    HITGroupId: string;
    /** - index */
    CreationTime?: string | null;
    /** - index */
    MaxAssignments: number;
    /** - index */
    Reward: string;
    /**
     * - default: `()`
     * - index
     */
    Expiration?: Moment | null;
    /**
     * - default: `3600`
     * - index
     */
    AssignmentDurationInSeconds?: number | null;
}

/**
 * Output type for MturkHIT.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface MturkHITOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * temporary flag for the few weeks while we have both mturk pipelines running in the same time. once legacy mturk is deprecated this can be removed
     * - computed: overwrite
     * - index
     */
    readonly isV2: boolean;
    /** - index */
    taskDefinition: Ref<'TaskDefinition'>;
    /** - index */
    task: Ref<'Task'>;
    /** - index */
    status: 'processing' | 'skip' | 'done' | 'error' | 'expired';
    error?: string | null;
    config?: Record<string, any> | null;
    result?: Record<string, any> | null;
    stats?: Record<string, any> | null;
    /** - default: `false` */
    empty: boolean;
    /** - default: `[]` */
    assignmentList: Array<{
        data: Record<string, any>;
        weight?: number | null;
        /** - index */
        AssignmentId: string;
        /** - index */
        WorkerId: string;
        AssignmentStatus?: string | null;
        AutoApprovalTime?: string | null;
        AcceptTime?: string | null;
        SubmitTime?: string | null;
        ApprovalTime?: string | null;
        Reason?: string | null;
    }>;
    /**
     * The full cost of this task, including amazon's cut
     * - default: `0`
     * - index
     */
    cost: number;
    /**
     * How many workers have to agree in order for this task to validate successfully.
     *
     * When majorityScore === 1 no consensus validation will be performed
     *
     * When majorityScore > 1, the task will start with majorityScore workers and continue asking for more workers until majorityScore workers agree (up to the maxAllowedAssignments limit)
     * - default: `1`
     * - index
     */
    majorityScore: number;
    /**
     * When majorityScore > 1 this field controls the maximum number of workers that will be added onto a task to attempt to get a majority.
     *
     * The task is considered failed if more workers are needed past this point
     * - default: `5`
     */
    maxAllowedAssignments: number;
    invalidAssignments?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** - default: `[]` */
    workers: Array<{
        /**
         * - computed: overwrite
         * - index
         */
        readonly mturkWorker: Ref<'MturkWorker'>;
        /** - index */
        AssignmentId: string;
        /** - index */
        WorkerId: string;
        /** - index */
        bonus: number;
        /** - index */
        fullBonus: number;
        /** - index */
        score: number;
        info?: Record<string, any> | null;
        /** - index */
        rejected?: string | null;
        /** - index */
        skipped?: string | null;
        /**
         * Feedback generated from the form-builder package that is used to display on the mturk feedback page. Every score reduction will be accompanied by an issue entry
         * - default: `[]`
         */
        issues: Array<Record<string, any>>;
        /**
         * When a worker sends us a message disputing some fields, and they turn out to be currect, we set isCorrect on the MturkMessage, and mark both the message and the worker as isConsolidated to show that these issues have overwritten the result
         *
         * NOTE: Consolidation is not yet implemented in mturk v2
         * - index
         */
        isConsolidated?: boolean | null;
    }>;
    /** - index */
    HITId: string;
    /** - index */
    HITTypeId: string;
    /** - index */
    HITGroupId: string;
    /** - index */
    CreationTime?: string | null;
    /** - index */
    MaxAssignments: number;
    /** - index */
    Reward: string;
    /**
     * - default: `()`
     * - index
     */
    Expiration: Moment;
    /**
     * - default: `3600`
     * - index
     */
    AssignmentDurationInSeconds: number;
}

/**
 * Input type for MturkWorker.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface MturkWorkerInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    WorkerId: string;
    /** - index */
    name?: string | null;
    /** - index */
    isBlocked?: boolean | null;
    /** - default: `[]` */
    attributes?: Array<{
        /**
         * - computed: default
         * - index
         */
        _id?: any | null;
        /** - index */
        type: string;
        /**
         * - default: `1`
         * - index
         */
        value?: number | null;
        /**
         * - default: `()`
         * - index
         */
        createdDate?: Moment | null;
        /** - index */
        createdBy?: Ref<'User'> | null;
    }> | null;
    /** - default: `[]` */
    qualifications?: Array<MturkWorkerQualificationInput> | null;
    /**
     * - computed: overwrite
     * - index
     */
    qualificationsCount?: number | null;
    /** - default: `[]` */
    revokedQualifications?: Array<MturkWorkerQualificationInput> | null;
    /**
     * - computed: overwrite
     * - index
     */
    revokedQualificationsCount?: number | null;
    /**
     * - default: `()`
     * - index
     */
    createdDate?: Moment | null;
    stats?: {
        /**
         * - default: `()`
         * - index
         */
        date?: Moment | null;
        total?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        threeMonths?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        oneMonth?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        /** - default: `[]` */
        perTaskTotal?: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }> | null;
        /** - default: `[]` */
        perTaskThreeMonths?: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }> | null;
        /** - default: `[]` */
        perTaskOneMonth?: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }> | null;
    } | null;
}

/**
 * Output type for MturkWorker.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface MturkWorkerOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    WorkerId: string;
    /** - index */
    name?: string | null;
    /** - index */
    isBlocked?: boolean | null;
    /** - default: `[]` */
    attributes: Array<{
        /**
         * - computed: default
         * - index
         */
        readonly _id: ObjectId | string;
        /** - index */
        type: string;
        /**
         * - default: `1`
         * - index
         */
        value: number;
        /**
         * - default: `()`
         * - index
         */
        createdDate: Moment;
        /** - index */
        createdBy?: Ref<'User'> | null;
    }>;
    /** - default: `[]` */
    qualifications: Array<MturkWorkerQualificationDoc>;
    /**
     * - computed: overwrite
     * - index
     */
    readonly qualificationsCount: number;
    /** - default: `[]` */
    revokedQualifications: Array<MturkWorkerQualificationDoc>;
    /**
     * - computed: overwrite
     * - index
     */
    readonly revokedQualificationsCount: number;
    /**
     * - default: `()`
     * - index
     */
    createdDate: Moment;
    stats?: {
        /**
         * - default: `()`
         * - index
         */
        date: Moment;
        total?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        threeMonths?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        oneMonth?: {
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        } | null;
        /** - default: `[]` */
        perTaskTotal: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }>;
        /** - default: `[]` */
        perTaskThreeMonths: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }>;
        /** - default: `[]` */
        perTaskOneMonth: Array<{
            /** - index */
            type: string;
            /** - index */
            total: number;
            /** - index */
            averageScore?: number | null;
            /** - index */
            totalIssues?: number | null;
            /** - index */
            averageIssues?: number | null;
            totalBonus?: number | null;
            totalFullBonus?: number | null;
            averageBonus?: number | null;
            /** - index */
            totalMessages?: number | null;
            totalCorrectMessages?: number | null;
            /** - index */
            correctMessageRatio?: number | null;
        }>;
    } | null;
}

/**
 * Input type for NfpAttributeMapping.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface NfpAttributeMappingInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    attributeValue: string;
    /** - index */
    attributeUofM: string;
    /** - index */
    attributeName: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for NfpAttributeMapping.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface NfpAttributeMappingOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    attributeValue: string;
    /** - index */
    attributeUofM: string;
    /** - index */
    attributeName: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Period.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface PeriodInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    circanaWeek: string;
    period: string;
    /** - default: `()` */
    startDate?: Moment | null;
    year: string;
    /** - default: `undefined` */
    snapshotStartTime?: Moment | null;
    /** - default: `undefined` */
    snapshotEndTime?: Moment | null;
    /** - default: `undefined` */
    adpStartTime?: Moment | null;
    /** - default: `undefined` */
    adpEndTime?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Period.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface PeriodOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    circanaWeek: string;
    period: string;
    /** - default: `()` */
    startDate: Moment;
    year: string;
    /** - default: `undefined` */
    snapshotStartTime?: Moment | null;
    /** - default: `undefined` */
    snapshotEndTime?: Moment | null;
    /** - default: `undefined` */
    adpStartTime?: Moment | null;
    /** - default: `undefined` */
    adpEndTime?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for PreProductionNtc.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Rows of a pre-production "new to code" (NTC) file, as loaded from the curvball GCS bucket. One document per row per ingestion event.
 */
export interface PreProductionNtcInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    ingestionEventId: Ref<'RawIngestionEvent'>;
    /** - index */
    upc: string;
    manufacturerCode?: string | null;
    /** Period the file covers, as "YYYYPP" (file column PERIOD) */
    period?: string | null;
    /** File column ITEM */
    itemDescription?: string | null;
    size?: string | null;
    /** File column U_OF_M */
    unitOfMeasure?: string | null;
    /** File column UPC_E */
    upcE?: string | null;
    dollars?: number | null;
    units?: number | null;
    /** File column SA, which carries "X" or a blank */
    spinsAlternative?: boolean | null;
    /** File column SG, which carries "X" or a blank */
    spinsGourmet?: boolean | null;
    /** File column SN, which carries "X" or a blank */
    spinsNatural?: boolean | null;
    /** File column SA_DOLLARS */
    spinsAlternativeDollars?: number | null;
    /** File column SG_DOLLARS */
    spinsGourmetDollars?: number | null;
    /** File column SN_DOLLARS */
    spinsNaturalDollars?: number | null;
    /** File column SA_UNITS */
    spinsAlternativeUnits?: number | null;
    /** File column SG_UNITS */
    spinsGourmetUnits?: number | null;
    /** File column SN_UNITS */
    spinsNaturalUnits?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** File column RETAILERBRAND */
    retailerBrand?: string | null;
    /** File column YTD_DOLLARS */
    ytdDollars?: number | null;
}

/**
 * Output type for PreProductionNtc.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Rows of a pre-production "new to code" (NTC) file, as loaded from the curvball GCS bucket. One document per row per ingestion event.
 */
export interface PreProductionNtcOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    ingestionEventId: Ref<'RawIngestionEvent'>;
    /** - index */
    upc: string;
    manufacturerCode?: string | null;
    /** Period the file covers, as "YYYYPP" (file column PERIOD) */
    period?: string | null;
    /** File column ITEM */
    itemDescription?: string | null;
    size?: string | null;
    /** File column U_OF_M */
    unitOfMeasure?: string | null;
    /** File column UPC_E */
    upcE?: string | null;
    dollars?: number | null;
    units?: number | null;
    /** File column SA, which carries "X" or a blank */
    spinsAlternative?: boolean | null;
    /** File column SG, which carries "X" or a blank */
    spinsGourmet?: boolean | null;
    /** File column SN, which carries "X" or a blank */
    spinsNatural?: boolean | null;
    /** File column SA_DOLLARS */
    spinsAlternativeDollars?: number | null;
    /** File column SG_DOLLARS */
    spinsGourmetDollars?: number | null;
    /** File column SN_DOLLARS */
    spinsNaturalDollars?: number | null;
    /** File column SA_UNITS */
    spinsAlternativeUnits?: number | null;
    /** File column SG_UNITS */
    spinsGourmetUnits?: number | null;
    /** File column SN_UNITS */
    spinsNaturalUnits?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** File column RETAILERBRAND */
    retailerBrand?: string | null;
    /** File column YTD_DOLLARS */
    ytdDollars?: number | null;
}

/**
 * Input type for PreProductionNtu.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Rows of a pre-production "new to update" (NTU) file, as loaded from the curvball GCS bucket. One document per row per ingestion event.
 */
export interface PreProductionNtuInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    ingestionEventId: Ref<'RawIngestionEvent'>;
    /** - index */
    upc: string;
    manufacturerCode?: string | null;
    /** Period the file covers, as "YYYYPP" (file column PERIOD) */
    period?: string | null;
    /** File column ITEM */
    itemDescription?: string | null;
    size?: string | null;
    /** File column U_OF_M */
    unitOfMeasure?: string | null;
    /** File column UPC_E */
    upcE?: string | null;
    dollars?: number | null;
    units?: number | null;
    /** File column SA, which carries "X" or a blank */
    spinsAlternative?: boolean | null;
    /** File column SG, which carries "X" or a blank */
    spinsGourmet?: boolean | null;
    /** File column SN, which carries "X" or a blank */
    spinsNatural?: boolean | null;
    /** File column SA_DOLLARS */
    spinsAlternativeDollars?: number | null;
    /** File column SG_DOLLARS */
    spinsGourmetDollars?: number | null;
    /** File column SN_DOLLARS */
    spinsNaturalDollars?: number | null;
    /** File column SA_UNITS */
    spinsAlternativeUnits?: number | null;
    /** File column SG_UNITS */
    spinsGourmetUnits?: number | null;
    /** File column SN_UNITS */
    spinsNaturalUnits?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** File column BRAND */
    brand?: string | null;
    /** File column GROUP_TAG */
    groupTag?: string | null;
    /** File column CATEGORY_TAG */
    categoryTag?: string | null;
}

/**
 * Output type for PreProductionNtu.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Rows of a pre-production "new to update" (NTU) file, as loaded from the curvball GCS bucket. One document per row per ingestion event.
 */
export interface PreProductionNtuOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    ingestionEventId: Ref<'RawIngestionEvent'>;
    /** - index */
    upc: string;
    manufacturerCode?: string | null;
    /** Period the file covers, as "YYYYPP" (file column PERIOD) */
    period?: string | null;
    /** File column ITEM */
    itemDescription?: string | null;
    size?: string | null;
    /** File column U_OF_M */
    unitOfMeasure?: string | null;
    /** File column UPC_E */
    upcE?: string | null;
    dollars?: number | null;
    units?: number | null;
    /** File column SA, which carries "X" or a blank */
    spinsAlternative?: boolean | null;
    /** File column SG, which carries "X" or a blank */
    spinsGourmet?: boolean | null;
    /** File column SN, which carries "X" or a blank */
    spinsNatural?: boolean | null;
    /** File column SA_DOLLARS */
    spinsAlternativeDollars?: number | null;
    /** File column SG_DOLLARS */
    spinsGourmetDollars?: number | null;
    /** File column SN_DOLLARS */
    spinsNaturalDollars?: number | null;
    /** File column SA_UNITS */
    spinsAlternativeUnits?: number | null;
    /** File column SG_UNITS */
    spinsGourmetUnits?: number | null;
    /** File column SN_UNITS */
    spinsNaturalUnits?: number | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** File column BRAND */
    brand?: string | null;
    /** File column GROUP_TAG */
    groupTag?: string | null;
    /** File column CATEGORY_TAG */
    categoryTag?: string | null;
}

/**
 * Input type for PredictionOverride.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface PredictionOverrideInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    attributeType: string;
    /** - index */
    asin?: string | null;
    /**
     * The GTIN of the CleansedData record this override was made against, denormalized so
     * the audit row remains identifiable if that record is merged away or deleted. Absent
     * for ASIN-only records, which legitimately carry no GTIN.
     * - index
     */
    gtin?: string | null;
    /** - index */
    cleansedDataId: Ref<'CleansedData'>;
    predictedValue?: string | null;
    updatedValue?: string | null;
    metadata?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for PredictionOverride.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface PredictionOverrideOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    attributeType: string;
    /** - index */
    asin?: string | null;
    /**
     * The GTIN of the CleansedData record this override was made against, denormalized so
     * the audit row remains identifiable if that record is merged away or deleted. Absent
     * for ASIN-only records, which legitimately carry no GTIN.
     * - index
     */
    gtin?: string | null;
    /** - index */
    cleansedDataId: Ref<'CleansedData'>;
    predictedValue?: string | null;
    updatedValue?: string | null;
    metadata?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for PrivateLabelPermanentProduct.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface PrivateLabelPermanentProductInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    oldUpc: string;
    /**
     * - index
     * - unique
     */
    upc: string;
}

/**
 * Output type for PrivateLabelPermanentProduct.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface PrivateLabelPermanentProductOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    oldUpc: string;
    /**
     * - index
     * - unique
     */
    upc: string;
}

/**
 * Input type for PrivateLabelProduct.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface PrivateLabelProductInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    upc: string;
    retailTag?: number | null;
    privateLabelBrand?: string | null;
    privateLabelDescription?: string | null;
    controlBrand?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for PrivateLabelProduct.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface PrivateLabelProductOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    upc: string;
    retailTag?: number | null;
    privateLabelBrand?: string | null;
    privateLabelDescription?: string | null;
    controlBrand?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for ProductEditRequest.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface ProductEditRequestInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `[]`
     * - index
     */
    products?: Array<Ref<'Pv2'>> | null;
    /**
     * - default: `[]`
     * - index
     */
    paths?: Array<string> | null;
    /**
     * - default: `false`
     * - index
     */
    resolved?: boolean | null;
    message: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for ProductEditRequest.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface ProductEditRequestOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `[]`
     * - index
     */
    products: Array<Ref<'Pv2'>>;
    /**
     * - default: `[]`
     * - index
     */
    paths: Array<string>;
    /**
     * - default: `false`
     * - index
     */
    resolved: boolean;
    message: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for ProductSentToTarget.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Record of product submission to Target from the target-publish-updated-products script.
 */
export interface ProductSentToTargetInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    pv2Id: Ref<'Pv2'>;
    targetEnv?: string | null;
    transformedVersion?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for ProductSentToTarget.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Record of product submission to Target from the target-publish-updated-products script.
 */
export interface ProductSentToTargetOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    pv2Id: Ref<'Pv2'>;
    targetEnv?: string | null;
    transformedVersion?: Record<string, any> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Pv2.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface Pv2Input {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - default: `pending` */
    status?:
        | (
              | 'pending'
              | 'processing'
              | 'active'
              | 'disabled'
              | 'discontinued'
              | 'active_reprocessing'
              | 'draft'
          )
        | null;
    notification?: {
        userId: Ref<'User'>;
        /** - default: `()` */
        date?: Moment | null;
    } | null;
    /** Full product name, user-friendly */
    name: string;
    /**
     * URL-friendly unique identifier for this product. It is generated from the product name and updates every time the name or brand changes
     * - computed: overwrite
     * - index
     */
    slug?: string | null;
    /** - index */
    brand?: Ref<'Company'> | null;
    /**
     * Manufacturer is computed from brand, but can sometimes be null which computed doesn't seem to allow for
     * - index
     */
    manufacturer?: Ref<'Company'> | null;
    /** - default: `[]` */
    companies?: Array<Ref<'Company'>> | null;
    /** - default: `[]` */
    barcodes?: Array<BarcodeStructInput> | null;
    /** - default: `false` */
    deliveredToCircana?: boolean | null;
    /** - default: `undefined` */
    firstDeliveredToSnapshot?: Moment | null;
    spinsAttributesEligibilityOverride?: boolean | null;
    /**
     * Computed alias of barcodes[0].GTIN, or an empty string if there are no barcodes
     * - default: ``
     * - computed: overwrite
     * - index
     */
    gtin?: string | null;
    /**
     * - default: ``
     * - index
     */
    spinsUpc?: string | null;
    /**
     * - default: ``
     * - index
     */
    maskedUpc?: string | null;
    /** - default: `[]` */
    asinChildren?: Array<Ref<'Pv2'>> | null;
    asin?: {
        /** - index */
        asin?: string | null;
        /** - index */
        associatedGtin?: string | null;
    } | null;
    /** - default: `[]` */
    identifiers?: Array<Pv2IdentifierInput> | null;
    /** - default: `[]` */
    ingestionMetadata?: Array<Pv2IngestionMetadataInput> | null;
    /** - default: `[]` */
    whitelists?: Array<Ref<'Whitelist'>> | null;
    /**
     * A list of domain IDs for which this Pv2 qualifies for visibility under GTIN de-duping logic
     * - default: `[]`
     */
    dedupeDomains?: Array<Ref<'Domain'>> | null;
    /** - default: `[]` */
    digitizationStores?: Array<Ref<'Store'>> | null;
    /**
     * Indicates if the stores list has ever been fully rebuilt.
     * - default: `false`
     * - computed: overwrite
     */
    digitizationStoresInitialized?: boolean | null;
    /** - default: `[]` */
    taxonomies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * Temporary field for SPINS hierarchy that behaves similarly to the taxonomies field. Ultimately this should
     * go away in favor of referencing SPINS hierarchy in the taxonomies field instead once the legacy Pinto
     * taxonomies are retired.
     * - default: `[]`
     */
    hierarchies?: Array<Ref<'Taxonomy'>> | null;
    /** - index */
    hierarchyOverride?: ('client' | 'ops' | 'tasker') | null;
    /** - index */
    source?:
        | (
              | 'manager'
              | 'aperture'
              | 'metro-gs1'
              | 'foodfacts'
              | 'product-library'
              | 'circana'
              | 'amazon'
              | 'ix-one'
          )
        | null;
    barcode128?: string | null;
    /** @deprecated Use containerChildren field instead */
    parentGTIN?: string | null;
    /** - default: `[]` */
    containerChildren?: Array<Ref<'Pv2'>> | null;
    /** - default: `()` */
    dataUpdatedDate?: Moment | null;
    /** - default: `unit` */
    itemType?: ('unit' | 'innerPack' | 'case' | 'pallet') | null;
    /** - default: `[]` */
    images?: Array<Ref<'Image'>> | null;
    imagesCount?: number | null;
    /** - default: `null` */
    imageUpdatedDate?: Moment | null;
    imageStatus?: {
        /** - index */
        state: 'pending' | 'processing' | 'done' | 'failed';
        /**
         * - default: `null`
         * - index
         */
        doneDate?: Moment | null;
    } | null;
    /** - default: `100` */
    processingPriority?: number | null;
    /**
     * Once new images are uploaded via the manager platform, all existing images are moved to outdatedImages for historical purposes
     * - default: `[]`
     */
    outdatedImages?: Array<Ref<'Image'>> | null;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    /** - default: `false` */
    overrideExclusivity?: boolean | null;
    exclusivity?: {
        /** - index */
        type: 'domain' | 'retailer' | 'none';
        /** - index */
        domain: Ref<'Domain'>;
    } | null;
    /** - default: `false` */
    overrideBarcodeGtinGeneration?: boolean | null;
    /** - default: `[]` */
    attributes?: Array<Pv2AttributeStructInput> | null;
    lastVerification?: {
        _id?: any | null;
        verifier?: Ref<'User'> | null;
        /** - index */
        upToDate: boolean;
        /**
         * - default: `()`
         * - index
         */
        date?: Moment | null;
    } | null;
    /** - default: `false` */
    needsVerification?: boolean | null;
    discontinued?: {
        /**
         * - default: `()`
         * - index
         */
        date?: Moment | null;
        user?: Ref<'User'> | null;
    } | null;
    digitizationStatus?: Pv2DigitizationStatusInput | null;
    /** - default: `[]` */
    digitizationOutOfStock?: Array<Pv2DigitizationOutOfStockInput> | null;
    digitizationStoreDone?: Pv2DigitizationStoreDoneInput | null;
    /** - index */
    copy?: Ref<'Pv2'> | null;
    /** - index */
    original?: Ref<'Pv2'> | null;
    /**
     * Indicates whether this Pv2 document is a draft version, i.e., the 'original' field is defined.
     * - default: `false`
     * - computed: overwrite
     */
    isCopy?: boolean | null;
    taskerStatus?: {
        state?: ('pending' | 'processing' | 'done') | null;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        pending?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        processing?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        async_sent?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        assigned?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        async_done?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        async_expired?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        done?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        error?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        blocked?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        disabled?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        invalid?: number | null;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        cancelled?: number | null;
        /**
         * - default: `null`
         * - index
         */
        startDate?: Moment | null;
        /**
         * - default: `null`
         * - index
         */
        doneDate?: Moment | null;
    } | null;
    /** - default: `[]` */
    pv2Ingredients?: Array<{
        /** - index */
        pv2Ingredient: Ref<'Pv2Ingredient'>;
        componentType: 'parsed' | 'sanitized' | 'majority' | 'parsed_cleaned';
    }> | null;
    /**
     * A list of formulas that output one or more invalid attributes on the last run (and thus did not get saved).
     * - default: `[]`
     */
    failedFormulas?: Array<Ref<'Formula'>> | null;
    /**
     * A flag indicating if failedFormulas is non-empty.
     * - default: `false`
     * - computed: overwrite
     * - index
     */
    hasFailedFormulas?: boolean | null;
    /**
     * The uids of attributes whose "parent" references an attribute uid that does not exist
     * on this Pv2. Only populated while parent validation is relaxed (i.e. the Pv2 is in the
     * pending or processing status); a non-empty list blocks promotion to the active status
     * and, for a copy, the merge back into its original.
     * - default: `[]`
     */
    invalidAttributeParents?: Array<string> | null;
    /**
     * A flag indicating if invalidAttributeParents is non-empty.
     * - default: `false`
     * - computed: overwrite
     */
    hasInvalidAttributeParents?: boolean | null;
    /**
     * Synchronized value from the circana:keycat attribute
     * - computed: overwrite
     * - index
     */
    circanaKeycat?: string | null;
    /** - index */
    cleansedData?: Ref<'CleansedData'> | null;
    /** - default: `[]` */
    mergedCopyPv2Ids?: Array<Ref<'Pv2'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Pv2.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface Pv2Output {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - default: `pending` */
    status:
        | 'pending'
        | 'processing'
        | 'active'
        | 'disabled'
        | 'discontinued'
        | 'active_reprocessing'
        | 'draft';
    notification?: {
        userId: Ref<'User'>;
        /** - default: `()` */
        date: Moment;
    } | null;
    /** Full product name, user-friendly */
    name: string;
    /**
     * URL-friendly unique identifier for this product. It is generated from the product name and updates every time the name or brand changes
     * - computed: overwrite
     * - index
     */
    readonly slug: string;
    /** - index */
    brand?: Ref<'Company'> | null;
    /**
     * Manufacturer is computed from brand, but can sometimes be null which computed doesn't seem to allow for
     * - index
     */
    manufacturer?: Ref<'Company'> | null;
    /** - default: `[]` */
    companies: Array<Ref<'Company'>>;
    /** - default: `[]` */
    barcodes: Array<BarcodeStructDoc>;
    /** - default: `false` */
    deliveredToCircana: boolean;
    /** - default: `undefined` */
    firstDeliveredToSnapshot?: Moment | null;
    spinsAttributesEligibilityOverride?: boolean | null;
    /**
     * Computed alias of barcodes[0].GTIN, or an empty string if there are no barcodes
     * - default: ``
     * - computed: overwrite
     * - index
     */
    readonly gtin: string;
    /**
     * - default: ``
     * - index
     */
    spinsUpc: string;
    /**
     * - default: ``
     * - index
     */
    maskedUpc: string;
    /** - default: `[]` */
    asinChildren: Array<Ref<'Pv2'>>;
    asin?: {
        /** - index */
        asin?: string | null;
        /** - index */
        associatedGtin?: string | null;
    } | null;
    /** - default: `[]` */
    identifiers: Array<Pv2IdentifierDoc>;
    /** - default: `[]` */
    ingestionMetadata: Array<Pv2IngestionMetadataDoc>;
    /** - default: `[]` */
    whitelists: Array<Ref<'Whitelist'>>;
    /**
     * A list of domain IDs for which this Pv2 qualifies for visibility under GTIN de-duping logic
     * - default: `[]`
     */
    dedupeDomains: Array<Ref<'Domain'>>;
    /** - default: `[]` */
    digitizationStores: Array<Ref<'Store'>>;
    /**
     * Indicates if the stores list has ever been fully rebuilt.
     * - default: `false`
     * - computed: overwrite
     */
    readonly digitizationStoresInitialized: boolean;
    /** - default: `[]` */
    taxonomies: Array<Ref<'Taxonomy'>>;
    /**
     * Temporary field for SPINS hierarchy that behaves similarly to the taxonomies field. Ultimately this should
     * go away in favor of referencing SPINS hierarchy in the taxonomies field instead once the legacy Pinto
     * taxonomies are retired.
     * - default: `[]`
     */
    hierarchies: Array<Ref<'Taxonomy'>>;
    /** - index */
    hierarchyOverride?: ('client' | 'ops' | 'tasker') | null;
    /** - index */
    source?:
        | (
              | 'manager'
              | 'aperture'
              | 'metro-gs1'
              | 'foodfacts'
              | 'product-library'
              | 'circana'
              | 'amazon'
              | 'ix-one'
          )
        | null;
    barcode128?: string | null;
    /** @deprecated Use containerChildren field instead */
    parentGTIN?: string | null;
    /** - default: `[]` */
    containerChildren: Array<Ref<'Pv2'>>;
    /** - default: `()` */
    dataUpdatedDate: Moment;
    /** - default: `unit` */
    itemType: 'unit' | 'innerPack' | 'case' | 'pallet';
    /** - default: `[]` */
    images: Array<Ref<'Image'>>;
    imagesCount?: number | null;
    /** - default: `null` */
    imageUpdatedDate?: Moment | null;
    imageStatus?: {
        /** - index */
        state: 'pending' | 'processing' | 'done' | 'failed';
        /**
         * - default: `null`
         * - index
         */
        doneDate?: Moment | null;
    } | null;
    /** - default: `100` */
    processingPriority: number;
    /**
     * Once new images are uploaded via the manager platform, all existing images are moved to outdatedImages for historical purposes
     * - default: `[]`
     */
    outdatedImages: Array<Ref<'Image'>>;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    /** - default: `false` */
    overrideExclusivity: boolean;
    exclusivity?: {
        /** - index */
        type: 'domain' | 'retailer' | 'none';
        /** - index */
        domain: Ref<'Domain'>;
    } | null;
    /** - default: `false` */
    overrideBarcodeGtinGeneration: boolean;
    /** - default: `[]` */
    attributes: Array<Pv2AttributeStructDoc>;
    lastVerification?: {
        readonly _id?: (ObjectId | string) | null;
        verifier?: Ref<'User'> | null;
        /** - index */
        upToDate: boolean;
        /**
         * - default: `()`
         * - index
         */
        date: Moment;
    } | null;
    /** - default: `false` */
    needsVerification: boolean;
    discontinued?: {
        /**
         * - default: `()`
         * - index
         */
        date: Moment;
        user?: Ref<'User'> | null;
    } | null;
    digitizationStatus?: Pv2DigitizationStatusDoc | null;
    /** - default: `[]` */
    digitizationOutOfStock: Array<Pv2DigitizationOutOfStockDoc>;
    digitizationStoreDone?: Pv2DigitizationStoreDoneDoc | null;
    /** - index */
    copy?: Ref<'Pv2'> | null;
    /** - index */
    original?: Ref<'Pv2'> | null;
    /**
     * Indicates whether this Pv2 document is a draft version, i.e., the 'original' field is defined.
     * - default: `false`
     * - computed: overwrite
     */
    readonly isCopy: boolean;
    taskerStatus?: {
        state?: ('pending' | 'processing' | 'done') | null;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        readonly pending: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly processing: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly async_sent: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly assigned: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly async_done: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly async_expired: number;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        readonly done: number;
        /**
         * - default: `0`
         * - computed: overwrite
         * - index
         */
        readonly error: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly blocked: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly disabled: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly invalid: number;
        /**
         * - default: `0`
         * - computed: overwrite
         */
        readonly cancelled: number;
        /**
         * - default: `null`
         * - index
         */
        startDate?: Moment | null;
        /**
         * - default: `null`
         * - index
         */
        doneDate?: Moment | null;
    } | null;
    /** - default: `[]` */
    pv2Ingredients: Array<{
        /** - index */
        pv2Ingredient: Ref<'Pv2Ingredient'>;
        componentType: 'parsed' | 'sanitized' | 'majority' | 'parsed_cleaned';
    }>;
    /**
     * A list of formulas that output one or more invalid attributes on the last run (and thus did not get saved).
     * - default: `[]`
     */
    failedFormulas: Array<Ref<'Formula'>>;
    /**
     * A flag indicating if failedFormulas is non-empty.
     * - default: `false`
     * - computed: overwrite
     * - index
     */
    readonly hasFailedFormulas: boolean;
    /**
     * The uids of attributes whose "parent" references an attribute uid that does not exist
     * on this Pv2. Only populated while parent validation is relaxed (i.e. the Pv2 is in the
     * pending or processing status); a non-empty list blocks promotion to the active status
     * and, for a copy, the merge back into its original.
     * - default: `[]`
     */
    invalidAttributeParents: Array<string>;
    /**
     * A flag indicating if invalidAttributeParents is non-empty.
     * - default: `false`
     * - computed: overwrite
     */
    readonly hasInvalidAttributeParents: boolean;
    /**
     * Synchronized value from the circana:keycat attribute
     * - computed: overwrite
     * - index
     */
    readonly circanaKeycat: string;
    /** - index */
    cleansedData?: Ref<'CleansedData'> | null;
    /** - default: `[]` */
    mergedCopyPv2Ids: Array<Ref<'Pv2'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Pv2AttributeDefinition.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Every single attribute "type" found in Pv2Attribute must be defined in here
 *
 * This collection stores the schema of every single attribute
 *
 * When Pv2 gets saved, all attributes are validated against this collection
 */
export interface Pv2AttributeDefinitionInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * Inactive attributes are ignored anywhere user-facing and are only used in internal tools. Mostly used during development
     * - default: `false`
     * - index
     */
    active?: boolean | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * The attribute type for this definition.
     * - index
     * - unique
     */
    type: string;
    /**
     * When the shape of this attribute meaningfully changes (schema, parents or hasKey is changed) this version number will auto-increment
     * - default: `0`
     * - computed: overwrite
     */
    version?: number | null;
    /**
     * Date at which the shape of this attribute has been changed.
     *
     * Previous versions of this attribute likely need to be updated via a database migration
     * - default: `()`
     * - computed: overwrite
     * - index
     */
    versionDate?: Moment | null;
    /**
     * Setting one or more domains will cause this attribute to be private and only visible to users of the given domains
     * - default: `[]`
     */
    domains?: Array<Ref<'Domain'>> | null;
    /**
     * Eligible legacy taxonomies for this attribute.
     * - default: `[]`
     */
    taxonomies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * Eligible spins hierarchies for this attribute.
     * - default: `[]`
     */
    hierarchies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * Attributes that do not have a key can only show up at most once in a Pv2
     * - default: `false`
     * - index
     */
    hasKey?: boolean | null;
    /**
     * All possible Pv2AttributeDefinition.type fields that this attribute can reference as a parent
     * - default: `[]`
     */
    parents?: Array<string> | null;
    /** External-facing description. Used in auto-generated attribute docs */
    description?: string | null;
    /**
     * Internal description that will only show up in the admin dashboard.
     *
     * Store attribute-specific notes in here where needed
     */
    internalDescription?: string | null;
    /**
     * Mark extra fields as required. "type" and "uid" are always required
     * - default: `[]`
     */
    required?: Array<'key' | 'parent' | 'source' | 'value'> | null;
    /**
     * If true "valueSchema" must be defined as a valid JSON Schema
     * - default: `true`
     * - index
     */
    hasValue?: boolean | null;
    _valueSchema?: string | null;
    /** - default: `[]` */
    changelog?: Array<ChangelogEntryStructInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    valueSchema?: JsonSchema | null;
}

/**
 * Output type for Pv2AttributeDefinition.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Every single attribute "type" found in Pv2Attribute must be defined in here
 *
 * This collection stores the schema of every single attribute
 *
 * When Pv2 gets saved, all attributes are validated against this collection
 */
export interface Pv2AttributeDefinitionOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * Inactive attributes are ignored anywhere user-facing and are only used in internal tools. Mostly used during development
     * - default: `false`
     * - index
     */
    active: boolean;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * The attribute type for this definition.
     * - index
     * - unique
     */
    type: string;
    /**
     * When the shape of this attribute meaningfully changes (schema, parents or hasKey is changed) this version number will auto-increment
     * - default: `0`
     * - computed: overwrite
     */
    readonly version: number;
    /**
     * Date at which the shape of this attribute has been changed.
     *
     * Previous versions of this attribute likely need to be updated via a database migration
     * - default: `()`
     * - computed: overwrite
     * - index
     */
    readonly versionDate: Moment;
    /**
     * Setting one or more domains will cause this attribute to be private and only visible to users of the given domains
     * - default: `[]`
     */
    domains: Array<Ref<'Domain'>>;
    /**
     * Eligible legacy taxonomies for this attribute.
     * - default: `[]`
     */
    taxonomies: Array<Ref<'Taxonomy'>>;
    /**
     * Eligible spins hierarchies for this attribute.
     * - default: `[]`
     */
    hierarchies: Array<Ref<'Taxonomy'>>;
    /**
     * Attributes that do not have a key can only show up at most once in a Pv2
     * - default: `false`
     * - index
     */
    hasKey: boolean;
    /**
     * All possible Pv2AttributeDefinition.type fields that this attribute can reference as a parent
     * - default: `[]`
     */
    parents: Array<string>;
    /** External-facing description. Used in auto-generated attribute docs */
    description?: string | null;
    /**
     * Internal description that will only show up in the admin dashboard.
     *
     * Store attribute-specific notes in here where needed
     */
    internalDescription?: string | null;
    /**
     * Mark extra fields as required. "type" and "uid" are always required
     * - default: `[]`
     */
    required: Array<'key' | 'parent' | 'source' | 'value'>;
    /**
     * If true "valueSchema" must be defined as a valid JSON Schema
     * - default: `true`
     * - index
     */
    hasValue: boolean;
    _valueSchema?: string | null;
    /** - default: `[]` */
    changelog: Array<ChangelogEntryStructDoc>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    valueSchema?: JsonSchema | null;
}

/**
 * Input type for Pv2CustomFieldConfig.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Pv2CustomFieldsConfig stores configurations for each use-case.
 * Configurations are attached to a domain and can optionally be scoped to one or more taxonomies.
 */
export interface Pv2CustomFieldConfigInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    type?: string | null;
    /** - index */
    domain: Ref<'Domain'>;
    /** - default: `[]` */
    taxonomies?: Array<Ref<'Taxonomy'>> | null;
    _value?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    value?: Pv2CustomFieldNode[] | null;
}

/**
 * Output type for Pv2CustomFieldConfig.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Pv2CustomFieldsConfig stores configurations for each use-case.
 * Configurations are attached to a domain and can optionally be scoped to one or more taxonomies.
 */
export interface Pv2CustomFieldConfigOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    type?: string | null;
    /** - index */
    domain: Ref<'Domain'>;
    /** - default: `[]` */
    taxonomies: Array<Ref<'Taxonomy'>>;
    _value?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    value: Pv2CustomFieldNode[];
}

/**
 * Input type for Pv2Ingredient.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface Pv2IngredientInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /** - index */
    componentType: 'parsed' | 'sanitized' | 'majority' | 'parsed_cleaned';
    /** - default: `undefined` */
    ingredientReview?: {
        reviewStatus: 'pending' | 'processing' | 'needsAdditionalReview' | 'done';
        /** - default: `undefined` */
        reviewer?: Ref<'User'> | null;
        /** - default: `undefined` */
        reviewStartDate?: Moment | null;
        /** - default: `undefined` */
        reviewCompleteDate?: Moment | null;
        /** - default: `undefined` */
        additionalReviewer?: Ref<'User'> | null;
        /** - default: `undefined` */
        additionalReviewStartDate?: Moment | null;
        /** - default: `undefined` */
        additionalReviewCompleteDate?: Moment | null;
    } | null;
    /**
     * - default: `()`
     * - index
     */
    createdDate?: Moment | null;
}

/**
 * Output type for Pv2Ingredient.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface Pv2IngredientOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /** - index */
    componentType: 'parsed' | 'sanitized' | 'majority' | 'parsed_cleaned';
    /** - default: `undefined` */
    ingredientReview?: {
        reviewStatus: 'pending' | 'processing' | 'needsAdditionalReview' | 'done';
        /** - default: `undefined` */
        reviewer?: Ref<'User'> | null;
        /** - default: `undefined` */
        reviewStartDate?: Moment | null;
        /** - default: `undefined` */
        reviewCompleteDate?: Moment | null;
        /** - default: `undefined` */
        additionalReviewer?: Ref<'User'> | null;
        /** - default: `undefined` */
        additionalReviewStartDate?: Moment | null;
        /** - default: `undefined` */
        additionalReviewCompleteDate?: Moment | null;
    } | null;
    /**
     * - default: `()`
     * - index
     */
    createdDate: Moment;
}

/**
 * Input type for Pv2Verification.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface Pv2VerificationInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    product: Ref<'Pv2'>;
    /** - index */
    verifier: Ref<'User'>;
    /** - index */
    upToDate: boolean;
    /**
     * - default: `()`
     * - index
     */
    date?: Moment | null;
}

/**
 * Output type for Pv2Verification.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface Pv2VerificationOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    product: Ref<'Pv2'>;
    /** - index */
    verifier: Ref<'User'>;
    /** - index */
    upToDate: boolean;
    /**
     * - default: `()`
     * - index
     */
    date: Moment;
}

/**
 * Input type for RawIngestionData.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Retains metadata for each row ingested during Circana or similar processes. Eventually pre-prod
 */
export interface RawIngestionDataInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    ingestionEventId?: Ref<'Ingestion'> | null;
    /** - index */
    gtin: string;
    data?: any /* Mixed type */ | null;
    /** - index */
    source: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for RawIngestionData.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Retains metadata for each row ingested during Circana or similar processes. Eventually pre-prod
 */
export interface RawIngestionDataOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    ingestionEventId?: Ref<'Ingestion'> | null;
    /** - index */
    gtin: string;
    data?: any /* Mixed type */ | null;
    /** - index */
    source: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for RawIngestionEvent.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Retains metadata for each ingestion event. Circana currently and eventually pre-prod
 */
export interface RawIngestionEventInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    rawIngestionCompleted?: Moment | null;
    /** - index */
    cleansedDataIngestionCompleted?: Moment | null;
    /**
     * The current status of this event.
     *
     * | status        | info                       |
     * |---------------|----------------------------|
     * | In Progress   | Ingestion is ongoing       |
     * | Completed     | Ingestion has finished     |
     * - index
     */
    status?: ('In Progress' | 'Completed' | 'Failed') | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for RawIngestionEvent.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Retains metadata for each ingestion event. Circana currently and eventually pre-prod
 */
export interface RawIngestionEventOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    rawIngestionCompleted?: Moment | null;
    /** - index */
    cleansedDataIngestionCompleted?: Moment | null;
    /**
     * The current status of this event.
     *
     * | status        | info                       |
     * |---------------|----------------------------|
     * | In Progress   | Ingestion is ongoing       |
     * | Completed     | Ingestion has finished     |
     * - index
     */
    status?: ('In Progress' | 'Completed' | 'Failed') | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for RetailItemsExtract.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Retains details about retail items extract jobs.
 */
export interface RetailItemsExtractInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /**
     * - default: `PENDING`
     * - index
     */
    status?: ('COMPLETED' | 'PROCESSING' | 'PENDING' | 'FAILED') | null;
    fileLocation: {
        googleCloudStorageUrl?: string | null;
        awsS3Url?: string | null;
    };
    _rawPayload?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    rawPayload?: (Record<string, any> | any[]) | null;
}

/**
 * Output type for RetailItemsExtract.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Retains details about retail items extract jobs.
 */
export interface RetailItemsExtractOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /**
     * - default: `PENDING`
     * - index
     */
    status: 'COMPLETED' | 'PROCESSING' | 'PENDING' | 'FAILED';
    fileLocation: {
        googleCloudStorageUrl?: string | null;
        awsS3Url?: string | null;
    };
    _rawPayload: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    rawPayload: Record<string, any> | any[];
}

/**
 * Input type for RetailerPrivateLabel.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Stores retailerId , retailTag, plBrand, controlBrand, and mfrCode information for retailers.
 */
export interface RetailerPrivateLabelInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - index
     * - unique
     */
    retailerId: number;
    /** - index */
    retailerTag?: number | null;
    plBrand?: string | null;
    controlBrand?: boolean | null;
    /** - index */
    mfrCode?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for RetailerPrivateLabel.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Stores retailerId , retailTag, plBrand, controlBrand, and mfrCode information for retailers.
 */
export interface RetailerPrivateLabelOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - index
     * - unique
     */
    retailerId: number;
    /** - index */
    retailerTag?: number | null;
    plBrand?: string | null;
    controlBrand?: boolean | null;
    /** - index */
    mfrCode?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Script.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface ScriptInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    fileName: string;
    fileLocation: 'api' | 'api-v2' | 'data-engineering';
    /** - default: `false` */
    isCron?: boolean | null;
    lastRunSucceeded?: boolean | null;
    /** Heap statistics of script process recorded from the most previous run. For more details see the following: https://nodejs.org/api/v8.html#v8getheapspacestatistics */
    heapStatistics?: {
        /** - default: `()` */
        timestamp?: Moment | null;
        totalHeapSize?: number | null;
        totalHeapSizeExecutable?: number | null;
        usedHeapSize?: number | null;
        heapSizeLimit?: number | null;
        mallocedMemory?: number | null;
        peakMallocedMemory?: number | null;
        numberOfNativeContexts?: number | null;
        numberOfDetachedContexts?: number | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Script.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface ScriptOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    fileName: string;
    fileLocation: 'api' | 'api-v2' | 'data-engineering';
    /** - default: `false` */
    isCron: boolean;
    lastRunSucceeded?: boolean | null;
    /** Heap statistics of script process recorded from the most previous run. For more details see the following: https://nodejs.org/api/v8.html#v8getheapspacestatistics */
    heapStatistics?: {
        /** - default: `()` */
        timestamp: Moment;
        totalHeapSize?: number | null;
        totalHeapSizeExecutable?: number | null;
        usedHeapSize?: number | null;
        heapSizeLimit?: number | null;
        mallocedMemory?: number | null;
        peakMallocedMemory?: number | null;
        numberOfNativeContexts?: number | null;
        numberOfDetachedContexts?: number | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for ServicesHeartbeat.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface ServicesHeartbeatInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /** - default: `[]` */
    lastCheckIn?: Array<{
        /** - index */
        displayName: string;
        /**
         * - default: `()`
         * - index
         */
        updatedDate?: Moment | null;
    }> | null;
    branchName?: string | null;
}

/**
 * Output type for ServicesHeartbeat.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface ServicesHeartbeatOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /** - default: `[]` */
    lastCheckIn: Array<{
        /** - index */
        displayName: string;
        /**
         * - default: `()`
         * - index
         */
        updatedDate: Moment;
    }>;
    branchName?: string | null;
}

/**
 * Input type for SnapshotTags.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface SnapshotTagsInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    spinsAttributeTypeId: Ref<'SpinsAttributeType'>;
    tagValue: string;
    descriptionValue: string;
    /** - default: `[]` */
    availableHierarchies?: Array<Ref<'Taxonomy'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for SnapshotTags.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface SnapshotTagsOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    spinsAttributeTypeId: Ref<'SpinsAttributeType'>;
    tagValue: string;
    descriptionValue: string;
    /** - default: `[]` */
    availableHierarchies: Array<Ref<'Taxonomy'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for SpinsAttributeType.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface SpinsAttributeTypeInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - default: `[]` */
    pv2SourceAttributes?: Array<Ref<'Pv2AttributeDefinition'>> | null;
    /** - unique */
    displayName: string;
    snapshotDescription?: string | null;
    snapshotTag?: string | null;
    snapshotEligible?: boolean | null;
    snapshotComputed?: boolean | null;
    adpPropEligible?: boolean | null;
    adpConvEligible?: boolean | null;
    piDirectEligible?: boolean | null;
    clientTrackerEligible?: boolean | null;
    adpReleasable?: boolean | null;
    adpIsMeasure?: boolean | null;
    measureUofM?: string | null;
    /** - default: `[]` */
    availableHierarchies?: Array<Ref<'Taxonomy'>> | null;
    /** - default: `[]` */
    privateLabelAvailableHierarchies?: Array<Ref<'Taxonomy'>> | null;
    attributeTheme?: {
        theme?: string | null;
        useCase?: string | null;
        type?: string | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for SpinsAttributeType.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface SpinsAttributeTypeOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - default: `[]` */
    pv2SourceAttributes: Array<Ref<'Pv2AttributeDefinition'>>;
    /** - unique */
    displayName: string;
    snapshotDescription?: string | null;
    snapshotTag?: string | null;
    snapshotEligible?: boolean | null;
    snapshotComputed?: boolean | null;
    adpPropEligible?: boolean | null;
    adpConvEligible?: boolean | null;
    piDirectEligible?: boolean | null;
    clientTrackerEligible?: boolean | null;
    adpReleasable?: boolean | null;
    adpIsMeasure?: boolean | null;
    measureUofM?: string | null;
    /** - default: `[]` */
    availableHierarchies: Array<Ref<'Taxonomy'>>;
    /** - default: `[]` */
    privateLabelAvailableHierarchies: Array<Ref<'Taxonomy'>>;
    attributeTheme?: {
        theme?: string | null;
        useCase?: string | null;
        type?: string | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for SpinsAttributes.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface SpinsAttributesInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    gtin?: string | null;
    /** - index */
    asin?: string | null;
    /** - index */
    associatedGtin?: string | null;
    /** - default: `[]` */
    attributes?: Array<{
        attributeName: string;
        attributeValue?: string | null;
    }> | null;
    /** - index */
    source?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy?: Ref<'User'> | null;
    /** - index */
    pv2Id: Ref<'Pv2'>;
    /**
     * - default: ``
     * - index
     */
    spinsUpc?: string | null;
}

/**
 * Output type for SpinsAttributes.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface SpinsAttributesOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    gtin?: string | null;
    /** - index */
    asin?: string | null;
    /** - index */
    associatedGtin?: string | null;
    /** - default: `[]` */
    attributes: Array<{
        attributeName: string;
        attributeValue?: string | null;
    }>;
    /** - index */
    source?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy: Ref<'User'>;
    /** - index */
    pv2Id: Ref<'Pv2'>;
    /**
     * - default: ``
     * - index
     */
    spinsUpc: string;
}

/**
 * Input type for Store.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface StoreInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    domain: Ref<'Domain'>;
    /**
     * partner-supplied Store ID, visible in the Digitization App
     * - index
     */
    storeID: string;
    name?: string | null;
    state?: string | null;
    city?: string | null;
    address?: string | null;
    county?: string | null;
    country?: string | null;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    /** - index */
    activeDigitization?: boolean | null;
    /** raw partner-specific data used to create this store */
    rawData?: Record<string, any> | null;
    /**
     * list of barcodes that are available in this store
     * - default: `[]`
     */
    availableUPCs?: Array<string> | null;
    /**
     * list of barcodes that are available in this store (without the hash prefix like availableUPCs has)
     * - default: `[]`
     */
    rawAvailableUPCs?: Array<string> | null;
    /**
     * Date when the store was closed. Typically pulled data from retailer ingestion.
     * - index
     */
    closedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Store.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface StoreOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    domain: Ref<'Domain'>;
    /**
     * partner-supplied Store ID, visible in the Digitization App
     * - index
     */
    storeID: string;
    name?: string | null;
    state?: string | null;
    city?: string | null;
    address?: string | null;
    county?: string | null;
    country?: string | null;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    /** - index */
    activeDigitization?: boolean | null;
    /** raw partner-specific data used to create this store */
    rawData?: Record<string, any> | null;
    /**
     * list of barcodes that are available in this store
     * - default: `[]`
     */
    availableUPCs: Array<string>;
    /**
     * list of barcodes that are available in this store (without the hash prefix like availableUPCs has)
     * - default: `[]`
     */
    rawAvailableUPCs: Array<string>;
    /**
     * Date when the store was closed. Typically pulled data from retailer ingestion.
     * - index
     */
    closedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Tag.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TagInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /** - default: `#ccc` */
    background?: string | null;
    /** - default: `#000` */
    color?: string | null;
    /**
     * - default: `user`
     * - index
     */
    type?: ('user' | 'system') | null;
    /**
     * All Domains have read and write access to this tag
     * - default: `[]`
     */
    domains?: Array<Ref<'Domain'>> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Tag.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TagOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /** - default: `#ccc` */
    background: string;
    /** - default: `#000` */
    color: string;
    /**
     * - default: `user`
     * - index
     */
    type: 'user' | 'system';
    /**
     * All Domains have read and write access to this tag
     * - default: `[]`
     */
    domains: Array<Ref<'Domain'>>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Task.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TaskInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    type: Ref<'TaskDefinition'>;
    /**
     * The current status of this Task.
     *
     * | status        | info                                                                                      |
     * |---------------|-------------------------------------------------------------------------------------------|
     * | pending       | Default initial status. Marks that the Task is waiting for processing                     |
     * | disabled      | Task has been disabled from automation. It must be manually set to "pending" status       |
     * | processing    | When Tasker picks up this Task to send it to a handler                                    |
     * | done          | Tasker received a successful result from the Task handler                                 |
     * | error         | Tasker received an error when processing. See "error-code" and "error" fields on the Task |
     * | blocked       | Task is waiting on its "taskDependencies" to start processing                             |
     * | async_sent    | Tasker has delivered this Task to an async handler for processing   |
     * | assigned      | Tasker has been accepted and assigned to a user                                           |
     * | async_done    | Async handler has successfully finished task. Transitions to "done" |
     * | async_expired | Async handler has failed to handle the task before its expiration time |
     * | cancelled     | Cancelled by a sibling task's "cancelSiblings" action                                     |
     * - default: `pending`
     * - index
     */
    status?: TaskStatusEnum | null;
    /**
     * - default: `()`
     * - computed: overwrite
     * - index
     */
    statusDate?: Moment | null;
    /** When status="error", this field will be set to the error body */
    error?: string | null;
    /**
     * When status="error", this field can optionally be set by the "resultTransformation"
     * - index
     */
    errorCode?: string | null;
    assignee?: {
        /** - default: `()` */
        startDate?: Moment | null;
        /** - default: `undefined` */
        endDate?: Moment | null;
        /**
         * Some tasks can be directly assigned to a user
         * - index
         */
        user: Ref<'User'>;
    } | null;
    /**
     * Higher priority tasks will be looked at first
     * - default: `1`
     * - index
     */
    priority?: number | null;
    processing?: {
        /** - default: `()` */
        startDate?: Moment | null;
        /** - default: `undefined` */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /**
         * The user that processed this task, if any
         * - index
         */
        assignee?: Ref<'User'> | null;
    } | null;
    /**
     * The parent task that created this document
     * - index
     */
    parentTask?: Ref<'Task'> | null;
    /**
     * A task will wait on all its taskDependencies before executing
     *
     * The result of all task dependencies will be available as `taskDependencies` as the task input
     * - default: `[]`
     */
    taskDependencies?: Array<Ref<'Task'>> | null;
    /** serialized JSON. Stores the input configuration for this task */
    _config?: string | null;
    /** serialized JSON. Stores the submitted result of this task once the given handler service has finished processing it */
    _result?: string | null;
    /** - default: `[]` */
    links?: Array<{
        /**
         * - computed: default
         * - index
         */
        _id?: any | null;
        targetModel: ModelName;
        /** - index */
        targetId: any;
    }> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    config?: Record<string, any> | null;
    /** @virtual */
    result?: any | null;
}

/**
 * Output type for Task.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TaskOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    type: Ref<'TaskDefinition'>;
    /**
     * The current status of this Task.
     *
     * | status        | info                                                                                      |
     * |---------------|-------------------------------------------------------------------------------------------|
     * | pending       | Default initial status. Marks that the Task is waiting for processing                     |
     * | disabled      | Task has been disabled from automation. It must be manually set to "pending" status       |
     * | processing    | When Tasker picks up this Task to send it to a handler                                    |
     * | done          | Tasker received a successful result from the Task handler                                 |
     * | error         | Tasker received an error when processing. See "error-code" and "error" fields on the Task |
     * | blocked       | Task is waiting on its "taskDependencies" to start processing                             |
     * | async_sent    | Tasker has delivered this Task to an async handler for processing   |
     * | assigned      | Tasker has been accepted and assigned to a user                                           |
     * | async_done    | Async handler has successfully finished task. Transitions to "done" |
     * | async_expired | Async handler has failed to handle the task before its expiration time |
     * | cancelled     | Cancelled by a sibling task's "cancelSiblings" action                                     |
     * - default: `pending`
     * - index
     */
    status: TaskStatusEnum;
    /**
     * - default: `()`
     * - computed: overwrite
     * - index
     */
    readonly statusDate: Moment;
    /** When status="error", this field will be set to the error body */
    error?: string | null;
    /**
     * When status="error", this field can optionally be set by the "resultTransformation"
     * - index
     */
    errorCode?: string | null;
    assignee?: {
        /** - default: `()` */
        startDate: Moment;
        /** - default: `undefined` */
        endDate?: Moment | null;
        /**
         * Some tasks can be directly assigned to a user
         * - index
         */
        user: Ref<'User'>;
    } | null;
    /**
     * Higher priority tasks will be looked at first
     * - default: `1`
     * - index
     */
    priority: number;
    processing?: {
        /** - default: `()` */
        startDate: Moment;
        /** - default: `undefined` */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /**
         * The user that processed this task, if any
         * - index
         */
        assignee?: Ref<'User'> | null;
    } | null;
    /**
     * The parent task that created this document
     * - index
     */
    parentTask?: Ref<'Task'> | null;
    /**
     * A task will wait on all its taskDependencies before executing
     *
     * The result of all task dependencies will be available as `taskDependencies` as the task input
     * - default: `[]`
     */
    taskDependencies: Array<Ref<'Task'>>;
    /** serialized JSON. Stores the input configuration for this task */
    _config?: string | null;
    /** serialized JSON. Stores the submitted result of this task once the given handler service has finished processing it */
    _result?: string | null;
    /** - default: `[]` */
    links: Array<{
        /**
         * - computed: default
         * - index
         */
        readonly _id: ObjectId | string;
        targetModel: ModelName;
        /** - index */
        readonly targetId: ObjectId | string;
    }>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    config: Record<string, any>;
    /** @virtual */
    result?: any | null;
}

/**
 * Input type for TaskDefinition.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TaskDefinitionInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - default: `false` */
    enabled?: boolean | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - index */
    type:
        | 'form_mturk'
        | 'form_internal'
        | 'image_annotator'
        | 'transformer'
        | 'image_inference'
        | 'url_validation'
        | 'url_search';
    /** Configuration specific to the task type + handler */
    config?: Record<string, any> | null;
    /** Optional Markdown description of what this task does */
    description?: string | null;
    /** If set, Tasker will give up waiting on the request after the given period and fail the task with a timeout error */
    timeoutSeconds?: number | null;
    /** - default: `{"perSecond":1,"maxProcessingAtOnce":10}` */
    throttle?: {
        /** Max number of requests to handle per second */
        perSecond?: number | null;
        /** Max number of tasks to have in a processing state in the same time */
        maxProcessingAtOnce?: number | null;
    } | null;
    /** Transformation to run on task completion */
    resultTransformation?: Ref<'TransformerExpression'> | null;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    mturk?: {
        /** - index */
        HITTypeId?: string | null;
        qualificationName?: string | null;
        QualificationTypeId?: string | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for TaskDefinition.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TaskDefinitionOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - default: `false` */
    enabled: boolean;
    /**
     * - index
     * - unique
     */
    name: string;
    /** - index */
    type:
        | 'form_mturk'
        | 'form_internal'
        | 'image_annotator'
        | 'transformer'
        | 'image_inference'
        | 'url_validation'
        | 'url_search';
    /** Configuration specific to the task type + handler */
    config?: Record<string, any> | null;
    /** Optional Markdown description of what this task does */
    description?: string | null;
    /** If set, Tasker will give up waiting on the request after the given period and fail the task with a timeout error */
    timeoutSeconds?: number | null;
    /** - default: `{"perSecond":1,"maxProcessingAtOnce":10}` */
    throttle: {
        /** Max number of requests to handle per second */
        perSecond?: number | null;
        /** Max number of tasks to have in a processing state in the same time */
        maxProcessingAtOnce?: number | null;
    };
    /** Transformation to run on task completion */
    resultTransformation?: Ref<'TransformerExpression'> | null;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    mturk?: {
        /** - index */
        HITTypeId?: string | null;
        qualificationName?: string | null;
        QualificationTypeId?: string | null;
    } | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for Taxonomy.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TaxonomyInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    /**
     * - computed: overwrite
     * - index
     */
    slug?: string | null;
    /**
     * - default: `0`
     * - index
     */
    depth?: number | null;
    breadcrumb?: string | null;
    description?: string | null;
    /** - index */
    parent?: Ref<'Taxonomy'> | null;
    RACC?: {
        /** - index */
        category: string;
        /** - index */
        value?: number | null;
        /** - index */
        unit?: number | null;
    } | null;
    /**
     * - default: `pinto`
     * - index
     */
    type?: ('pinto' | 'spins') | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Taxonomy.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TaxonomyOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    /**
     * - computed: overwrite
     * - index
     */
    readonly slug: string;
    /**
     * - default: `0`
     * - index
     */
    depth: number;
    breadcrumb?: string | null;
    description?: string | null;
    /** - index */
    parent?: Ref<'Taxonomy'> | null;
    RACC?: {
        /** - index */
        category: string;
        /** - index */
        value?: number | null;
        /** - index */
        unit?: number | null;
    } | null;
    /**
     * - default: `pinto`
     * - index
     */
    type: 'pinto' | 'spins';
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

/**
 * Input type for TransformerExpression.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TransformerExpressionInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `0`
     * - computed: default
     */
    version?: number | null;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * Different transformation types have access to different nodes based un use-case
     * - default: `default`
     * - index
     */
    type?: ('default' | 'taskDependency' | 'taskResult') | null;
    /**
     * Some transformations can be linked directly to a TaskDefinition
     * - index
     */
    taskDefinition?: Ref<'TaskDefinition'> | null;
    description?: string | null;
    _value?: string | null;
    /** - default: `[]` */
    changelog?: Array<ChangelogEntryStructInput> | null;
    outputType?: string | null;
    inputType?: string | null;
    /** - default: `[]` */
    dataRequirements?: Array<DataRequirementInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    value?: TransformerExpressionSchema | null;
}

/**
 * Output type for TransformerExpression.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TransformerExpressionOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `0`
     * - computed: default
     */
    version: number;
    /**
     * - index
     * - unique
     */
    name: string;
    /**
     * Different transformation types have access to different nodes based un use-case
     * - default: `default`
     * - index
     */
    type: 'default' | 'taskDependency' | 'taskResult';
    /**
     * Some transformations can be linked directly to a TaskDefinition
     * - index
     */
    taskDefinition?: Ref<'TaskDefinition'> | null;
    description?: string | null;
    _value: string;
    /** - default: `[]` */
    changelog: Array<ChangelogEntryStructDoc>;
    outputType?: string | null;
    inputType?: string | null;
    /** - default: `[]` */
    dataRequirements: Array<DataRequirementOutput>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    value: TransformerExpressionSchema;
}

/**
 * Input type for TransformerResource.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface TransformerResourceInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - default: `0` */
    version?: number | null;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    _value?: string | null;
    /**
     * - computed: overwrite
     * - unique
     */
    s3Path?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    value?: (Record<string, any> | any[]) | null;
}

/**
 * Output type for TransformerResource.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface TransformerResourceOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - default: `0` */
    version: number;
    /**
     * - index
     * - unique
     */
    name: string;
    description?: string | null;
    _value: string;
    /**
     * - computed: overwrite
     * - unique
     */
    readonly s3Path: string;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    value: Record<string, any> | any[];
}

/**
 * Input type for User.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface UserInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    firstName: string;
    lastName?: string | null;
    _password?: string | null;
    /**
     * - index
     * - unique
     */
    email: string;
    /**
     * - index
     * - unique
     */
    auth0Id?: string | null;
    avatar?: {
        small?: string | null;
        large?: string | null;
    } | null;
    /** @deprecated legacy, remove */
    isPhotoEntry?: boolean | null;
    /** - index */
    mturkWorker?: Ref<'MturkWorker'> | null;
    /**
     * - default: `user`
     * - index
     */
    role?: ('internal' | 'admin' | 'user') | null;
    receivedGettingStartedEmail?: boolean | null;
    digitization?: {
        /** - index */
        domain: Ref<'Domain'>;
        /** - index */
        store?: string | null;
        /**
         * - default: `high`
         * - index
         */
        priority?: ('high' | 'low' | 'all') | null;
        /**
         * - default: `runner`
         * - index
         */
        mode?: ('photographer' | 'runner') | null;
        /**
         * @deprecated use workflows instead
         * - index
         */
        workflow?: ('digitization' | 'dimensions') | null;
        /**
         * - default: `["photography"]`
         * - index
         */
        workflows?: Array<'photography' | 'dimensions' | 'enterprise' | 'foodService'> | null;
        /** - default: `true` */
        verificationFlow?: boolean | null;
    } | null;
    /**
     * Global user abilities
     * - default: `[]`
     */
    abilities?: Array<UserAbilitiesEnum> | null;
    tasker?: {
        /**
         * - default: `false`
         * - index
         */
        enabled?: boolean | null;
        /**
         * - default: `[]`
         * - index
         */
        tags?: Array<string> | null;
        /** - default: `[]` */
        tasks?: Array<Ref<'TaskDefinition'>> | null;
    } | null;
    pv2CustomFieldPrimary?: Ref<'Pv2CustomFieldConfig'> | null;
    /** - default: `[]` */
    pv2CustomFields?: Array<Ref<'Pv2CustomFieldConfig'>> | null;
    /** - default: `[]` */
    tags?: Array<TagStructInput> | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    passwordResetCode?: string | null;
    /** @virtual */
    password?: (string | null) | null;
    /** @virtual */
    photoEntry?: this['digitization'] | null;
}

/**
 * Output type for User.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface UserOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    firstName: string;
    lastName?: string | null;
    _password?: string | null;
    /**
     * - index
     * - unique
     */
    email: string;
    /**
     * - index
     * - unique
     */
    auth0Id?: string | null;
    avatar?: {
        small?: string | null;
        large?: string | null;
    } | null;
    /** @deprecated legacy, remove */
    isPhotoEntry?: boolean | null;
    /** - index */
    mturkWorker?: Ref<'MturkWorker'> | null;
    /**
     * - default: `user`
     * - index
     */
    role: 'internal' | 'admin' | 'user';
    receivedGettingStartedEmail?: boolean | null;
    digitization?: {
        /** - index */
        domain: Ref<'Domain'>;
        /** - index */
        store?: string | null;
        /**
         * - default: `high`
         * - index
         */
        priority: 'high' | 'low' | 'all';
        /**
         * - default: `runner`
         * - index
         */
        mode: 'photographer' | 'runner';
        /**
         * @deprecated use workflows instead
         * - index
         */
        workflow?: ('digitization' | 'dimensions') | null;
        /**
         * - default: `["photography"]`
         * - index
         */
        workflows: Array<'photography' | 'dimensions' | 'enterprise' | 'foodService'>;
        /** - default: `true` */
        verificationFlow: boolean;
    } | null;
    /**
     * Global user abilities
     * - default: `[]`
     */
    abilities: Array<UserAbilitiesEnum>;
    tasker?: {
        /**
         * - default: `false`
         * - index
         */
        enabled: boolean;
        /**
         * - default: `[]`
         * - index
         */
        tags: Array<string>;
        /** - default: `[]` */
        tasks: Array<Ref<'TaskDefinition'>>;
    } | null;
    pv2CustomFieldPrimary?: Ref<'Pv2CustomFieldConfig'> | null;
    /** - default: `[]` */
    pv2CustomFields: Array<Ref<'Pv2CustomFieldConfig'>>;
    /** - default: `[]` */
    tags: Array<TagStructDoc>;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    passwordResetCode?: string | null;
    /** @virtual */
    readonly isAdmin: boolean;
    /** @virtual */
    password?: (string | null) | null;
    /** @virtual */
    readonly displayName: string;
    /** @virtual */
    photoEntry?: this['digitization'] | null;
}

/**
 * Input type for UserBatch.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * Retains details about user export jobs
 */
export interface UserBatchInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * - default: `pending`
     * - index
     */
    status?: ('pending' | 'processing' | 'done' | 'error' | 'cancelled') | null;
    type: 'data' | 'images';
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate?: Moment | null;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
    } | null;
    /** - computed: default */
    name?: string | null;
    /** - computed: overwrite */
    s3Key?: string | null;
    /**
     * When enabled, an email will be sent to the user that created this batch
     * - default: `true`
     */
    notifyByEmail?: boolean | null;
    userFacingError?: string | null;
    internalError?: string | null;
    _query?: string | null;
    filetype?: ('CSV' | 'JSON') | null;
    exportAllProducts?: boolean | null;
    /** - default: `[]` */
    gtins?: Array<string> | null;
    /** - default: `[]` */
    productIds?: Array<string> | null;
    /** - default: `[]` */
    images?: Array<
        'FRONT' | 'FRONT_THUMBNAIL' | 'FRONT_PLANOGRAM' | 'ALL' | 'ALL_THUMBNAIL' | 'ALL_PLANOGRAM'
    > | null;
    urlFormat?: ('STANDARD' | 'WFMOA' | 'GS1') | null;
    /** - default: `[]` */
    sections?: Array<string> | null;
    batchServerId?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    query?: Record<string, any> | null;
}

/**
 * Output type for UserBatch.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * Retains details about user export jobs
 */
export interface UserBatchOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * - default: `pending`
     * - index
     */
    status: 'pending' | 'processing' | 'done' | 'error' | 'cancelled';
    type: 'data' | 'images';
    processing?: {
        /**
         * - default: `()`
         * - index
         */
        startDate: Moment;
        /**
         * - default: `undefined`
         * - index
         */
        endDate?: Moment | null;
        /** - index */
        durationInSeconds?: number | null;
        /** - index */
        numProducts?: number | null;
    } | null;
    /** - computed: default */
    name: string;
    /** - computed: overwrite */
    readonly s3Key: string;
    /**
     * When enabled, an email will be sent to the user that created this batch
     * - default: `true`
     */
    notifyByEmail: boolean;
    userFacingError?: string | null;
    internalError?: string | null;
    _query?: string | null;
    filetype?: ('CSV' | 'JSON') | null;
    exportAllProducts?: boolean | null;
    /** - default: `[]` */
    gtins: Array<string>;
    /** - default: `[]` */
    productIds: Array<string>;
    /** - default: `[]` */
    images: Array<
        'FRONT' | 'FRONT_THUMBNAIL' | 'FRONT_PLANOGRAM' | 'ALL' | 'ALL_THUMBNAIL' | 'ALL_PLANOGRAM'
    >;
    urlFormat?: ('STANDARD' | 'WFMOA' | 'GS1') | null;
    /** - default: `[]` */
    sections: Array<string>;
    batchServerId?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    query?: Record<string, any> | null;
}

/**
 * Input type for UserSearch.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 *
 * In the retailer dashboard users can build search queries and optionally save those searches
 * A saved search is stored in the UserSearch model
 */
export interface UserSearchInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /** - index */
    name: string;
    _structure?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    structure?: Record<string, any> | null;
}

/**
 * Output type for UserSearch.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 *
 * In the retailer dashboard users can build search queries and optionally save those searches
 * A saved search is stored in the UserSearch model
 */
export interface UserSearchOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /** - index */
    name: string;
    _structure?: string | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    structure: Record<string, any>;
}

/**
 * Input type for Whitelist.
 *
 * Only required fields that are not computed and don't have a default are marked as mandatory
 */
export interface WhitelistInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    name: string;
    /** - default: `[]` */
    rawBarcodes?: Array<string> | null;
    /**
     * - default: `[]`
     * - computed: overwrite
     * - index
     */
    normalizedGtins?: Array<string> | null;
    /**
     * - default: `[]`
     * - index
     */
    pv2s?: Array<Ref<'Pv2'>> | null;
    /** - index */
    domain: Ref<'Domain'>;
    /** - default: `false` */
    writeAccess?: boolean | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy?: Ref<'User'> | null;
}

/**
 * Output type for Whitelist.
 *
 * Mandatory fields are everything marked as required, computed or with a non-nullish default
 */
export interface WhitelistOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    name: string;
    /** - default: `[]` */
    rawBarcodes: Array<string>;
    /**
     * - default: `[]`
     * - computed: overwrite
     * - index
     */
    readonly normalizedGtins: Array<string>;
    /**
     * - default: `[]`
     * - index
     */
    pv2s: Array<Ref<'Pv2'>>;
    /** - index */
    domain: Ref<'Domain'>;
    /** - default: `false` */
    writeAccess: boolean;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     * - index
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     * - index
     */
    updatedBy: Ref<'User'>;
}

export interface ApertureAnnotationStructDoc extends ApertureAnnotationStructOutput {}

export interface ApertureAnnotationStructInput {
    /**
     * - computed: default
     * - index
     */
    _id?: any | null;
    /**
     * Determines the shape of the value attribute
     * There can be multiple attributes with the same type in a product
     */
    type: string;
    /** - index */
    name: string;
    confidence?: number | null;
    /** Could be string, number, or boolean */
    _value?: string | null;
    box?: any /* Mixed type */ | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     */
    updatedDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy?: Ref<'User'> | null;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy?: Ref<'User'> | null;
    /** @virtual */
    value?: (string | number | boolean) | null;
}

export interface ApertureAnnotationStructOutput {
    /**
     * - computed: default
     * - index
     */
    readonly _id: ObjectId | string;
    /**
     * Determines the shape of the value attribute
     * There can be multiple attributes with the same type in a product
     */
    type: string;
    /** - index */
    name: string;
    confidence?: number | null;
    /** Could be string, number, or boolean */
    _value?: string | null;
    box?: any /* Mixed type */ | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdDate: Moment;
    /**
     * Defaulted to current date via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - default: `()`
     * - computed: default
     */
    updatedDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     */
    createdBy: Ref<'User'>;
    /**
     * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
     *
     * Gets overwritten after every "Document.save()", unless it has been manually changed.
     * - computed: default
     */
    updatedBy: Ref<'User'>;
    /** @virtual */
    value: string | number | boolean;
}

export interface BarcodeStructDoc extends BarcodeStructOutput {}

export interface BarcodeStructInput {
    /**
     * - computed: overwrite
     * - index
     */
    GTIN?: string | null;
    /** @deprecated */
    source?: string | null;
    /** - default: `null` */
    domain?: Ref<'Domain'> | null;
    original: string;
    /** - computed: overwrite */
    format?: string | null;
    options?: {
        addCheckDigit?: boolean | null;
        shouldTrimLeadingZeros?: boolean | null;
    } | null;
    /** - default: `()` */
    date?: Moment | null;
    isPrivateLabel?: boolean | null;
    hash?: string | null;
}

export interface BarcodeStructOutput {
    /**
     * - computed: overwrite
     * - index
     */
    readonly GTIN: string;
    /** @deprecated */
    source?: string | null;
    /** - default: `null` */
    domain?: Ref<'Domain'> | null;
    original: string;
    /** - computed: overwrite */
    readonly format: string;
    options?: {
        addCheckDigit?: boolean | null;
        shouldTrimLeadingZeros?: boolean | null;
    } | null;
    /** - default: `()` */
    date: Moment;
    isPrivateLabel?: boolean | null;
    hash?: string | null;
}

export interface ChangelogEntryStructDoc extends ChangelogEntryStructOutput {}

export interface ChangelogEntryStructInput {
    version: number;
    message: string;
    /** - default: `()` */
    date?: Moment | null;
    user: Ref<'User'>;
}

export interface ChangelogEntryStructOutput {
    version: number;
    message: string;
    /** - default: `()` */
    date: Moment;
    user: Ref<'User'>;
}

export interface CleansedDataAllergenInformationDoc extends CleansedDataAllergenInformationOutput {}

export interface CleansedDataAllergenInformationInput {
    allergenTypeCode?: string | null;
    levelOfContainmentCode?: string | null;
}

export interface CleansedDataAllergenInformationOutput {
    allergenTypeCode?: string | null;
    levelOfContainmentCode?: string | null;
}

export interface CleansedDataNutritionFactsDoc extends CleansedDataNutritionFactsOutput {}

export interface CleansedDataNutritionFactsInput {
    name?: string | null;
    value?: number | null;
    unit?: string | null;
    dailyValue?: number | null;
    panel?: string | null;
}

export interface CleansedDataNutritionFactsOutput {
    name?: string | null;
    value?: number | null;
    unit?: string | null;
    dailyValue?: number | null;
    panel?: string | null;
}

export interface CleansedDataPointAllergenInformationDoc
    extends CleansedDataPointAllergenInformationOutput {}

export interface CleansedDataPointAllergenInformationInput {
    /** - default: `[]` */
    value?: Array<CleansedDataAllergenInformationInput> | null;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointAllergenInformationOutput {
    /** - default: `[]` */
    value: Array<CleansedDataAllergenInformationDoc>;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointNutritionFactsDoc extends CleansedDataPointNutritionFactsOutput {}

export interface CleansedDataPointNutritionFactsInput {
    /** - default: `[]` */
    value?: Array<CleansedDataNutritionFactsInput> | null;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointNutritionFactsOutput {
    /** - default: `[]` */
    value: Array<CleansedDataNutritionFactsDoc>;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointServingInformationDoc
    extends CleansedDataPointServingInformationOutput {}

export interface CleansedDataPointServingInformationInput {
    /** - default: `[]` */
    value?: Array<CleansedDataServingInformationInput> | null;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointServingInformationOutput {
    /** - default: `[]` */
    value: Array<CleansedDataServingInformationDoc>;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointSourceSpecificDoc extends CleansedDataPointSourceSpecificOutput {}

export interface CleansedDataPointSourceSpecificInput {
    value: any /* Mixed type */;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointSourceSpecificOutput {
    value: any /* Mixed type */;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointStringDoc extends CleansedDataPointStringOutput {}

export interface CleansedDataPointStringInput {
    value: string;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointStringOutput {
    value: string;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointSupplementFactsDoc
    extends CleansedDataPointSupplementFactsOutput {}

export interface CleansedDataPointSupplementFactsInput {
    /** - default: `[]` */
    value?: Array<CleansedDataSupplementFactsInput> | null;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate?: Moment | null;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataPointSupplementFactsOutput {
    /** - default: `[]` */
    value: Array<CleansedDataSupplementFactsDoc>;
    source:
        | 'rivir'
        | 'stackline'
        | 'stacklineSales'
        | 'clearcut'
        | 'keepa'
        | 'predictions:daap-hierarchy'
        | 'predictions:attribution-agent'
        | 'predictions:override'
        | 'predictions:nfp-agent'
        | 'aperture'
        | 'circana'
        | 'preprod:ntc'
        | 'preprod:ntu'
        | 'preprod:sales';
    /** The first raw ingestion event where this value changed or was introduced */
    ingestionEvent?: Ref<'RawIngestionEvent'> | null;
    /**
     * The date when this value was changed or introduced
     * - default: `()`
     */
    valueUpdatedDate: Moment;
    /** The ASIN attached to this data point, if one was included */
    asin?: string | null;
    /** The Rivir ID attached to this data point, if one was included */
    rivirId?: string | null;
}

export interface CleansedDataServingInformationDoc extends CleansedDataServingInformationOutput {}

export interface CleansedDataServingInformationInput {
    panel?: string | null;
    servingSize?: number | null;
    servingSizeMeasurement?: string | null;
    servingSizeDescription?: string | null;
    calories?: number | null;
    servingsPerContainer?: number | null;
}

export interface CleansedDataServingInformationOutput {
    panel?: string | null;
    servingSize?: number | null;
    servingSizeMeasurement?: string | null;
    servingSizeDescription?: string | null;
    calories?: number | null;
    servingsPerContainer?: number | null;
}

export interface CleansedDataSupplementFactsDoc extends CleansedDataSupplementFactsOutput {}

export interface CleansedDataSupplementFactsInput {
    servingsPerContainer?: number | null;
    calories?: number | null;
    caloriesFromFat?: number | null;
    path?: string | null;
    servingSize?: string | null;
    otherIngredients?: string | null;
    footnotes?: string | null;
    /** - default: `[]` */
    nutrients?: Array<{
        name?: string | null;
        descriptor?: string | null;
        value?: number | null;
        unit?: string | null;
        dailyValue?: number | null;
        path?: string | null;
        dailySymbol?: string | null;
    }> | null;
}

export interface CleansedDataSupplementFactsOutput {
    servingsPerContainer?: number | null;
    calories?: number | null;
    caloriesFromFat?: number | null;
    path?: string | null;
    servingSize?: string | null;
    otherIngredients?: string | null;
    footnotes?: string | null;
    /** - default: `[]` */
    nutrients: Array<{
        name?: string | null;
        descriptor?: string | null;
        value?: number | null;
        unit?: string | null;
        dailyValue?: number | null;
        path?: string | null;
        dailySymbol?: string | null;
    }>;
}

export interface DataRequirementModelDoc extends DataRequirementModelOutput {}

export interface DataRequirementModelIdDoc extends DataRequirementModelIdOutput {}

export interface DataRequirementModelIdInput {
    targetModel: ModelName;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray?: boolean | null;
    optional?: boolean | null;
    kind: 'modelId';
}

export interface DataRequirementModelIdOutput {
    targetModel: ModelName;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray: boolean;
    optional?: boolean | null;
    kind: 'modelId';
}

export interface DataRequirementModelInput {
    targetModel: ModelName;
    /**
     * Optional fields to select. If left empty, everything will be selected
     * - default: `[]`
     */
    selectFields?: Array<string> | null;
    /**
     * Optional fields to populate
     * - default: `[]`
     */
    populateFields?: Array<string> | null;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray?: boolean | null;
    optional?: boolean | null;
    kind: 'model';
}

export interface DataRequirementModelOutput {
    targetModel: ModelName;
    /**
     * Optional fields to select. If left empty, everything will be selected
     * - default: `[]`
     */
    selectFields: Array<string>;
    /**
     * Optional fields to populate
     * - default: `[]`
     */
    populateFields: Array<string>;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray: boolean;
    optional?: boolean | null;
    kind: 'model';
}

export interface DataRequirementPrimitiveDoc extends DataRequirementPrimitiveOutput {}

export interface DataRequirementPrimitiveInput {
    primitiveType?: ('string' | 'boolean' | 'number' | 'object') | null;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray?: boolean | null;
    optional?: boolean | null;
    kind: 'primitive';
}

export interface DataRequirementPrimitiveOutput {
    primitiveType?: ('string' | 'boolean' | 'number' | 'object') | null;
    /** Variable name */
    name: string;
    /**
     * Make this a list of entries
     * - default: `false`
     */
    isArray: boolean;
    optional?: boolean | null;
    kind: 'primitive';
}

export interface DomainCompanyDoc extends DomainCompanyOutput {}

export interface DomainCompanyInput {
    /** - index */
    access?: DomainCompanyAccessEnum | null;
    /** - index */
    profileAccess?: DomainCompanyProfileAccessEnum | null;
    /** - index */
    company: Ref<'Company'>;
}

export interface DomainCompanyOutput {
    /** - index */
    access?: DomainCompanyAccessEnum | null;
    /** - index */
    profileAccess?: DomainCompanyProfileAccessEnum | null;
    /** - index */
    company: Ref<'Company'>;
}

export interface DomainTaxonomyDoc extends DomainTaxonomyOutput {}

export interface DomainTaxonomyInput {
    /** - index */
    taxonomy: Ref<'Taxonomy'>;
}

export interface DomainTaxonomyOutput {
    /** - index */
    taxonomy: Ref<'Taxonomy'>;
}

export interface DomainUserDoc extends DomainUserOutput {}

export interface DomainUserInput {
    /** - index */
    user: Ref<'User'>;
    /**
     * User access level
     * - user: can only read data
     * - manager: can read and write products
     * - admin: can manage the domain and all its products
     * - index
     */
    role: DomainUserRoleEnum;
    /**
     * Manual user abilities applied to users by a super admin (or potentially a domain admin)
     *
     * For all computed user abilities see the getUserAbilities() utility
     * - default: `[]`
     */
    abilities?: Array<DomainUserAbilitiesEnum> | null;
    /** - index */
    invitedBy?: Ref<'User'> | null;
    inviteMessage?: string | null;
    /**
     * - default: `null`
     * - index
     */
    acceptedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate?: Moment | null;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy?: Ref<'User'> | null;
}

export interface DomainUserOutput {
    /** - index */
    user: Ref<'User'>;
    /**
     * User access level
     * - user: can only read data
     * - manager: can read and write products
     * - admin: can manage the domain and all its products
     * - index
     */
    role: DomainUserRoleEnum;
    /**
     * Manual user abilities applied to users by a super admin (or potentially a domain admin)
     *
     * For all computed user abilities see the getUserAbilities() utility
     * - default: `[]`
     */
    abilities: Array<DomainUserAbilitiesEnum>;
    /** - index */
    invitedBy?: Ref<'User'> | null;
    inviteMessage?: string | null;
    /**
     * - default: `null`
     * - index
     */
    acceptedDate?: Moment | null;
    /**
     * Defaulted to current date via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdDate: Moment;
    /**
     * Defaulted to current "doc.context.user" via trackingProps mongoose plugin
     * - default: `null`
     * - computed: default
     * - index
     */
    createdBy: Ref<'User'>;
}

export interface HierarchyMappingChildRuleDoc extends HierarchyMappingChildRuleOutput {}

export interface HierarchyMappingChildRuleInput {
    taxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `standard` */
    type?: ('standard' | 'lookup') | null;
    /** - default: `[]` */
    conditions?: Array<HierarchyMappingConditionInput> | null;
    lookupAttribute?: string | null;
    /** - default: `[]` */
    lookupOptions?: Array<HierarchyMappingLookupOptionInput> | null;
}

export interface HierarchyMappingChildRuleOutput {
    taxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `standard` */
    type: 'standard' | 'lookup';
    /** - default: `[]` */
    conditions: Array<HierarchyMappingConditionDoc>;
    lookupAttribute?: string | null;
    /** - default: `[]` */
    lookupOptions: Array<HierarchyMappingLookupOptionDoc>;
}

export interface HierarchyMappingConditionDoc extends HierarchyMappingConditionOutput {}

export interface HierarchyMappingConditionInput {
    attribute: string;
    /** - default: `exact` */
    matchType?:
        | (
              | 'exact'
              | 'contains'
              | 'notContains'
              | 'containsWord'
              | 'notContainsWord'
              | 'exists'
              | 'notExists'
          )
        | null;
    /** - default: `[]` */
    values?: Array<string> | null;
}

export interface HierarchyMappingConditionOutput {
    attribute: string;
    /** - default: `exact` */
    matchType:
        | 'exact'
        | 'contains'
        | 'notContains'
        | 'containsWord'
        | 'notContainsWord'
        | 'exists'
        | 'notExists';
    /** - default: `[]` */
    values: Array<string>;
}

export interface HierarchyMappingLookupOptionDoc extends HierarchyMappingLookupOptionOutput {}

export interface HierarchyMappingLookupOptionInput {
    /** - default: `[]` */
    values?: Array<string> | null;
    taxonomy: Ref<'Taxonomy'>;
}

export interface HierarchyMappingLookupOptionOutput {
    /** - default: `[]` */
    values: Array<string>;
    taxonomy: Ref<'Taxonomy'>;
}

export interface HierarchyMappingRuleDoc extends HierarchyMappingRuleOutput {}

export interface HierarchyMappingRuleInput {
    taxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `standard` */
    type?: ('standard' | 'lookup') | null;
    lookupAttribute?: string | null;
    /** - default: `[]` */
    lookupOptions?: Array<HierarchyMappingLookupOptionInput> | null;
    /** - default: `[]` */
    conditions?: Array<HierarchyMappingConditionInput> | null;
    /** - default: `[]` */
    children?: Array<HierarchyMappingChildRuleInput> | null;
}

export interface HierarchyMappingRuleOutput {
    taxonomy?: Ref<'Taxonomy'> | null;
    /** - default: `standard` */
    type: 'standard' | 'lookup';
    lookupAttribute?: string | null;
    /** - default: `[]` */
    lookupOptions: Array<HierarchyMappingLookupOptionDoc>;
    /** - default: `[]` */
    conditions: Array<HierarchyMappingConditionDoc>;
    /** - default: `[]` */
    children: Array<HierarchyMappingChildRuleDoc>;
}

export interface ImageUrlDoc extends ImageUrlOutput {}

export interface ImageUrlInput {
    type: 'thumbnail' | 'main' | 'raw' | 'crop';
    url: string;
    s3Key?: string | null;
    sizeMb?: number | null;
    width?: number | null;
    height?: number | null;
    /** - default: `()` */
    date?: Moment | null;
    user?: Ref<'User'> | null;
}

export interface ImageUrlOutput {
    type: 'thumbnail' | 'main' | 'raw' | 'crop';
    url: string;
    s3Key?: string | null;
    sizeMb?: number | null;
    width?: number | null;
    height?: number | null;
    /** - default: `()` */
    date: Moment;
    user?: Ref<'User'> | null;
}

export interface MturkWorkerQualificationDoc extends MturkWorkerQualificationOutput {}

export interface MturkWorkerQualificationInput {
    /** - index */
    QualificationTypeId: string;
    /** - default: `1` */
    IntegerValue?: number | null;
    /** - default: `()` */
    GrantTime?: Moment | null;
    Reason?: string | null;
}

export interface MturkWorkerQualificationOutput {
    /** - index */
    QualificationTypeId: string;
    /** - default: `1` */
    IntegerValue: number;
    /** - default: `()` */
    GrantTime: Moment;
    Reason?: string | null;
}

export interface Pv2AttributeStructDoc extends Pv2AttributeStructOutput {}

export interface Pv2AttributeStructInput {
    /**
     * Determines the shape of the value attribute
     * There can be multiple attributes with the same type in a product
     * - index
     */
    type: string;
    /**
     * Distinguishes between multiple attributes of the same __type__, when necessary
     *
     * Usually used in conjunction with the __parent__ attribute to reference unique fields
     * We use keys instead of attribute ___id__s since we usually don't know the ids at creation time
     *
     * ### Example:
     *
     * A product with multiple __nutrition: panel__ attributes needs to distinguish between them
     *
     * At creation time, each get an unique __key__ (unique among all other __nutrition: panel__ attributes in this Pv2)
     * - default: `undefined`
     */
    key?: string | null;
    /**
     * Combination of __type__ + __key__ to create an unique identifier for this attribute
     *
     * The __parent__ field will reference another attribute's __uid__ for explicit linking
     * - default: `undefined`
     */
    uid?: string | null;
    /**
     * Where did we get this attribute from?
     *
     * Whether from a computation (computed), from the physical package (on-package) or from the brand/manufacturer directly (off-package)
     * - default: `undefined`
     */
    source?: ('computed' | 'on-package' | 'off-package' | 'third-party' | 'multisource') | null;
    /**
     * Standard way of linking attributes together within the same Pv2 document
     *
     * The reference is to another attribute's __uid__ field
     */
    parent?: string | null;
    /** Specific shape depending on each attribute type */
    value?: any /* Mixed type */ | null;
    /** The data source that provided this attribute value */
    dataProvider?: 'circana' | null;
    /**
     * - default: `undefined`
     * - computed: overwrite
     */
    createdDate?: Moment | null;
    /**
     * - default: `undefined`
     * - computed: overwrite
     */
    valueUpdatedDate?: Moment | null;
    /**
     * The task that provided the attribute value.
     * - index
     */
    task?: Ref<'Task'> | null;
}

export interface Pv2AttributeStructOutput {
    /**
     * Determines the shape of the value attribute
     * There can be multiple attributes with the same type in a product
     * - index
     */
    type: string;
    /**
     * Distinguishes between multiple attributes of the same __type__, when necessary
     *
     * Usually used in conjunction with the __parent__ attribute to reference unique fields
     * We use keys instead of attribute ___id__s since we usually don't know the ids at creation time
     *
     * ### Example:
     *
     * A product with multiple __nutrition: panel__ attributes needs to distinguish between them
     *
     * At creation time, each get an unique __key__ (unique among all other __nutrition: panel__ attributes in this Pv2)
     * - default: `undefined`
     */
    key?: string | null;
    /**
     * Combination of __type__ + __key__ to create an unique identifier for this attribute
     *
     * The __parent__ field will reference another attribute's __uid__ for explicit linking
     * - default: `undefined`
     */
    uid?: string | null;
    /**
     * Where did we get this attribute from?
     *
     * Whether from a computation (computed), from the physical package (on-package) or from the brand/manufacturer directly (off-package)
     * - default: `undefined`
     */
    source?: ('computed' | 'on-package' | 'off-package' | 'third-party' | 'multisource') | null;
    /**
     * Standard way of linking attributes together within the same Pv2 document
     *
     * The reference is to another attribute's __uid__ field
     */
    parent?: string | null;
    /** Specific shape depending on each attribute type */
    value?: any /* Mixed type */ | null;
    /** The data source that provided this attribute value */
    dataProvider?: 'circana' | null;
    /**
     * - default: `undefined`
     * - computed: overwrite
     */
    readonly createdDate: Moment;
    /**
     * - default: `undefined`
     * - computed: overwrite
     */
    readonly valueUpdatedDate: Moment;
    /**
     * The task that provided the attribute value.
     * - index
     */
    task?: Ref<'Task'> | null;
}

export interface Pv2DigitizationOutOfStockDoc extends Pv2DigitizationOutOfStockOutput {}

export interface Pv2DigitizationOutOfStockInput {
    store: string;
    user: Ref<'User'>;
    /** - default: `()` */
    date?: Moment | null;
}

export interface Pv2DigitizationOutOfStockOutput {
    store: string;
    user: Ref<'User'>;
    /** - default: `()` */
    date: Moment;
}

export interface Pv2DigitizationStatusDoc extends Pv2DigitizationStatusOutput {}

export interface Pv2DigitizationStatusInput {
    status: 'none' | 'pending' | 'cart' | 'done';
    /** - default: `()` */
    date?: Moment | null;
    user?: Ref<'User'> | null;
    domain?: Ref<'Domain'> | null;
    store?: string | null;
}

export interface Pv2DigitizationStatusOutput {
    status: 'none' | 'pending' | 'cart' | 'done';
    /** - default: `()` */
    date: Moment;
    user?: Ref<'User'> | null;
    domain?: Ref<'Domain'> | null;
    store?: string | null;
}

export interface Pv2DigitizationStoreDoneDoc extends Pv2DigitizationStoreDoneOutput {}

export interface Pv2DigitizationStoreDoneInput {
    user?: Ref<'User'> | null;
    store?: string | null;
    /** - default: `()` */
    date?: Moment | null;
}

export interface Pv2DigitizationStoreDoneOutput {
    user?: Ref<'User'> | null;
    store?: string | null;
    /** - default: `()` */
    date: Moment;
}

export interface Pv2IdentifierDoc extends Pv2IdentifierOutput {}

export interface Pv2IdentifierInput {
    /**
     * - computed: overwrite
     * - index
     */
    hash?: string | null;
    /** - index */
    domain?: Ref<'Domain'> | null;
    value: string;
}

export interface Pv2IdentifierOutput {
    /**
     * - computed: overwrite
     * - index
     */
    readonly hash: string;
    /** - index */
    domain?: Ref<'Domain'> | null;
    value: string;
}

export interface Pv2IngestionMetadataDoc extends Pv2IngestionMetadataOutput {}

export interface Pv2IngestionMetadataInput {
    /** - index */
    domain?: Ref<'Domain'> | null;
    brand?: string | null;
    category?: string | null;
    subcategory?: string | null;
    rawPayload?: Record<string, any> | null;
}

export interface Pv2IngestionMetadataOutput {
    /** - index */
    domain?: Ref<'Domain'> | null;
    brand?: string | null;
    category?: string | null;
    subcategory?: string | null;
    rawPayload?: Record<string, any> | null;
}

export interface ScannedBarcodesDoc extends ScannedBarcodesOutput {}

export interface ScannedBarcodesInput {
    /** - index */
    type: string;
    /** - index */
    value: string;
}

export interface ScannedBarcodesOutput {
    /** - index */
    type: string;
    /** - index */
    value: string;
}

export interface TagStructDoc extends TagStructOutput {}

export interface TagStructInput {
    /** - index */
    name: string;
    reason?: string | null;
    /** - index */
    data?: Ref<'Tag'> | null;
    /** - default: `undefined` */
    createdBy?: Ref<'User'> | null;
    /** - default: `()` */
    createdDate?: Moment | null;
}

export interface TagStructOutput {
    /** - index */
    name: string;
    reason?: string | null;
    /** - index */
    data?: Ref<'Tag'> | null;
    /** - default: `undefined` */
    createdBy?: Ref<'User'> | null;
    /** - default: `()` */
    createdDate: Moment;
}

export type BrandMatchReasonEnum =
    | 'same_name_different_spacing'
    | 'one_name_starts_the_other'
    | 'one_name_inside_the_other'
    | 'possible_misspelling';

export type BrandReviewReasonEnum =
    | 'same_brand_spelling_variant'
    | 'same_brand_spacing_or_punctuation'
    | 'same_brand_typo'
    | 'sub_brand_should_merge'
    | 'sub_brand_distinct'
    | 'retailer_private_label_family'
    | 'unrelated_brands'
    | 'substring_collision'
    | 'other';

export type BrandReviewStatusEnum = 'pending' | 'approved' | 'rejected' | 'needsAdditionalReview';

export type BuilderBatchSaveToFileFormatEnum = 'jsonl' | 'csv';

export type DataRequirementDoc =
    | DataRequirementModelDoc
    | DataRequirementModelIdDoc
    | DataRequirementPrimitiveDoc;

export type DataRequirementInput =
    | DataRequirementModelIdInput
    | DataRequirementModelInput
    | DataRequirementPrimitiveInput;

export type DataRequirementOutput =
    | DataRequirementModelIdOutput
    | DataRequirementModelOutput
    | DataRequirementPrimitiveOutput;

export type DomainCompanyAccessEnum = 'view' | 'edit';

export type DomainCompanyProfileAccessEnum = 'view' | 'edit';

export type DomainDigitizationModeEnum = 'whitelist' | 'blacklist';

export type DomainMembershipEnum = 'basic' | 'complianceBasic' | 'pro' | 'enterprise';

export type DomainUserAbilitiesEnum = 'use_batch_api' | 'use_digitization_app';

export type DomainUserRoleEnum =
    | 'standard'
    | 'manager'
    | 'admin'
    | 'complianceBasic'
    | 'complianceAdmin';

export type ModelNameEnum = ModelName;

export type TaskStatusEnum =
    | 'pending'
    | 'processing'
    | 'async_sent'
    | 'assigned'
    | 'async_done'
    | 'async_expired'
    | 'done'
    | 'error'
    | 'blocked'
    | 'disabled'
    | 'invalid'
    | 'cancelled';

export type UserAbilitiesEnum =
    | 'circana_manager'
    | 'image_processing'
    | 'configure_feature_flags'
    | 'cost_and_billing';
